<template>
  <!-- New Order Creation -->
  <div>
    <modal v-if="isNewOrderModal" :title="$t('OrderCurrent.modal.newOrder')" @close-request="clearNewOrderModal();"
    closable>
      <new-zone-modal
      v-if="showNewZoneModal"
      @closeModal="closeZoneModal"
      :billingLatLong="{lat: billingLatLong.lat, long: billingLatLong.long}"
      :transmitterLatLong="{lat: order.transmitterLat, long: order.transmitterLong}"
      :receiverLatLong="{lat: order.receiverLat, long: order.receiverLong}"
      :billingType="billingType"
      />
      
      <div class="mx-3">
        <div class="row">
          <delivery-location-details ref="delivLocDetails" :order="order" :selectedDealer.sync="billingDealer"
            :isPendingOrder="isPendingOrder" @update:selectedDealer="setSelectedDealer" :showBilling="true" :allowIdentities="true"
            :addressbook="addressbook" @sendSelectedEmails="updateSelectedEmails"
            @calculateZonePrice="handleZoneUpdate"
            :vehicles="vehicles"
            @update:order.transmitterZoneId="handleZoneUpdate"
            @update:order.receiverZoneId="handleZoneUpdate"
            @toggleZoneModal="toggleZoneModal"
            :isFromMarketplace="isFromMarketplace"
            :zoneData="zoneData"
            @sageSelected="onSageSelected"
            @fuelChargeIncluded="onFuelChargeIncluded"
            @logistics-contact-validation="updateLogisticsContactValidation"
            >
          </delivery-location-details>
          <!-- ORDER -->
          <div class="col-12 col-lg-6 mt-2" id="Order">
            <h4 class="kne-title">{{ $t('OrderPending.orderTab.order') }}</h4>
            <div>
              <regular-input :value="order.source" @input="order.source = $event" type="text"
                :placeholder="$t('OrderPending.orderTab.source')" class="form-group" />
            </div>
  
            <div>
              <label>{{ $t('OrderCurrent.datePromis') }}</label>
              <regular-input :value="order.datePromis" @input="order.datePromis = $event" type="date"
                :placeholder="$t('OrderPending.orderTab.datePromis')" class="form-group" />
            </div>
            <div>
              <regular-input :value="order.numRef" @input="order.numRef = $event" type="text"
                :placeholder="$t('OrderPending.orderTab.reference')" class="form-group" />
            </div>
            <div>
              <regular-textarea :value="order.comment" @input="order.comment = $event" rows="4"
                :placeholder="$t('OrderPending.orderTab.comment')" class="form-group" />
            </div>
          </div>
  
          <!-- CAR INFO -->
          <div class="col-12 col-lg-6 mt-2" id="vehicle">
            <h4 class="kne-title">{{ isDryBox ? $t('DryBox.pallet_info') : $t('OrderCurrent.modal.carInfo.vehicle_info') }}</h4>

            <!-- Checkbox to allow user to enter custom vehicle details -->
            <regular-checkbox v-if="!isDryBox" :id="'custom-vin-checkbox'" :checked="isVinCustom" @change="toggleCustomVin"
              :label="$t('OrderCurrent.modal.carInfo.custom_details')" class="mb-2" />

            <div v-if="!isDryBox && isVinCustom">
              <regular-input :value="VIN" @input="vinValidator" type="text"
                :placeholder="$t('OrderCurrent.modal.carInfo.VIN')" class="form-group"
                :class="{ 'input--missing': isValidVin === true }" />
              <p class="form-group h6 text-danger" v-if="this.vinError">{{ this.vinError }}</p>
              <p class="form-group h6 text-warning" v-if="this.matchedVins.length > 0">{{ 'We found an existing order with VIN: ' + this.matchedVins[0].vin + ' and Order Number: ' + this.matchedVins[0].orderNumber }}</p>
  
              <regular-input :value="YEAR" @input="yearValidator" type="number"
                :placeholder="$t('OrderCurrent.modal.carInfo.year')" class="form-group"
                :class="{ 'input--missing': isValidVin === true }" />
              <p class="form-group h6 text-danger" v-if="this.yearError">{{ this.yearError }}</p>
  
              <regular-input :value="MAKE" @input="MAKE = $event" type="text"
                :placeholder="$t('OrderCurrent.modal.carInfo.make')" class="form-group"
                :class="{ 'input--missing': isValidVin === true }" />
              <regular-input :value="MODEL" @input="MODEL = $event" type="text"
                :placeholder="$t('OrderCurrent.modal.carInfo.model')" class="form-group"
                :class="{ 'input--missing': isValidVin === true }" />
              <regular-input :value="TRIM" @input="TRIM = $event" type="text"
                :placeholder="$t('OrderCurrent.modal.carInfo.trim')" class="form-group"
                :class="{ 'input--missing': isValidVin === true }" />
              <div class="toggleSwitch mb-3" v-if="buttonList">
                <toggle-switch ref="toggleSwitch" class="border" :optionList="buttonList" :multiple="false"
                  @emitSelectedOption="updateOptionSelect" @setOption="updateOption" />
  
                <hover-tool-tip v-if="sizeTooltipText" class="mx-2" :clickable="false" :text="sizeTooltipText"
                  :iconColor="sizeTooltipColor" top left />
              </div>
              <regular-input :value="WEIGHT" @input="WEIGHT = $event" type="number"
                :placeholder="$t('OrderCurrent.modal.carInfo.weight')" class="form-group"
                :class="{ 'input--missing': isValidVin === true }" />
            </div>
  
            <div v-if="!isDryBox && !isVinCustom">
              <div>
                <regular-input :value="getVIN" @input="VIN = $event" type="text"
                  :placeholder="$t('OrderCurrent.modal.carInfo.VIN')" class="form-group"
                  :class="{ 'input--missing': isValidVin === true }" />
              <p class="form-group h6 text-warning" v-if="this.matchedVins.length > 0">{{ 'We found an existing order with VIN: ' + this.matchedVins[0].vin + ' and Order Number: ' + this.matchedVins[0].orderNumber }}</p>
                <div class="mb-2">
                  <button class="btn btn-kne-orange w-100 form-group" :disabled="VIN === ''"
                    @click="validateVIN(VIN)">{{ $t('OrderCurrent.modal.carInfo.validate') }}</button>
                  <p class="mb-2 classification-error-text" v-if="vinErrorMsg !== '' && !isPendingOrder">{{ vinErrorMsg
                    }}</p>
                </div>
              </div>
  
              <regular-select :value="getYear" @change="onSubmitVehicleYear"
                :placeholder="$t('OrderCurrent.modal.carInfo.year')" class="border form-group">
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
              </regular-select>
  
              <!-- Make -->
              <autocomplete :disabled="!(YEAR !== '')" :search="searchCarMake" :default-value="getMake"
                ref="autocomplete" class="form-group" :class="{ 'input--missing': !(YEAR !== '') }"
                :placeholder="$t('OrderCurrent.modal.carInfo.make')" @submit="onSubmitCarMake">
              </autocomplete>
  
              <!-- Model -->
              <autocomplete :disabled="typeof MAKE === 'undefined' || !(YEAR !== '' && MAKE !== '')"
                :search="searchCarModel" :default-value="getModel" ref="autocomplete2" class="form-group"
                :class="{ 'input--missing': typeof MAKE === 'undefined' || !(YEAR !== '' && MAKE !== '') }"
                :placeholder="$t('OrderCurrent.modal.carInfo.model')" @keyup="MODEL = $event.target._value"
                @submit="onSubmitCarModel">
              </autocomplete>
  
              <!-- Trim -->
              <regular-select v-if="!vinErrorMsg" :value="selectedTrimDetails.trimName" @change="onSubmitCarTrim"
                :disabled="trimOptions.length === 0" :placeholder="$t('OrderCurrent.modal.carInfo.trim')"
                class="border form-group">
                <option v-for="trim in trimOptions" :key="trim.trimName" :value="trim.trimName">{{ trim.trimName }}
                </option>
              </regular-select>
              <regular-input v-else :value="TRIM" @input="TRIM = $event" type="text"
                :placeholder="$t('OrderCurrent.modal.carInfo.trim')" class="form-group"
                :class="{ 'input--missing': isValidVin === true }" />
  
              <div class="toggleSwitch" v-if="buttonList">
                <div>
                  <div class="d-flex">
                    <toggle-switch ref="toggleSwitch" class="border toggle-switch" :optionList="buttonList"
                      :multiple="false" @emitSelectedOption="updateOptionSelect" @setOption="updateOption" />
                    <hover-tool-tip v-if="sizeTooltipText !== ''" class="mx-2" :clickable="false"
                      :text="sizeTooltipText" :iconColor="sizeTooltipColor" top left />
  
                  </div>
                  <!-- Classification Error Messages -->
                  <div class="classification-text mt-2 classification-error-text"
                    v-if="!isPendingOrder && showClassificationMessageType === 'error'">{{ classificationMessage }}</div>
                  <div class="classification-text mt-2 classification-success-text"
                    v-if="!isPendingOrder && showClassificationMessageType === 'success'">{{ classificationMessage }}</div>
                </div>
                <div>
  
                  <!-- <regular-input :value="WEIGHT" @input="WEIGHT = $event"
                    :disabled="typeof TRIM === 'undefined' || !(YEAR !== '' && MAKE !== '' && MODEL !== '' && TRIM !== '')"
                    type="text" :placeholder="$t('OrderCurrent.modal.carInfo.weight')"
                    :class="{ 'input--missing': isValidVin === true }" /> -->
  
                  <div v-if="showVolumetricWeightDetails">
                    <!-- Volumetric weight -->
                    <regular-input :fontSize="vw_fontSize"
                      :value="`${$t('OrderCurrent.modal.carInfo.volumetric_weight')}: ${WEIGHT || 'NA'}`"
                      :disabled="true" type="text" :placeholder="$t('OrderCurrent.modal.carInfo.volumetric_weight')"
                      class="mt-3" :class="{ 'input--missing': isValidVin === true }" />
                    <regular-input :fontSize="vw_fontSize"
                      :value="`${$t('OrderCurrent.modal.carInfo.weight')}: ${selectedTrimDetails['weight'] || 'NA'}`"
                      :disabled="true" type="text" :placeholder="$t('OrderCurrent.modal.carInfo.weight')"
                      class="mt-3" :class="{ 'input--missing': isValidVin === true }" />
                    <div class="d-flex align-items-center mt-1 formula">
                      <!-- length -->
                      <div class="d-flex flex-column gap-2 align-items-center justify-content-center">
                        <p class="mb-1">{{ $t('OrderCurrent.modal.carInfo.length') }}(cm)</p>
                        <regular-input :value="selectedTrimDetails['length'] || 'NA'" :disabled="true" type="text"
                          :placeholder="$t('OrderCurrent.modal.carInfo.length')" class="mx-2" :fontSize="vw_fontSize"
                          :class="{ 'input--missing': isValidVin === true }" style="width: 60px" />
                      </div>
                      <p class="mt-3">x</p>
                      <!-- width -->
                      <div class="d-flex flex-column gap-2 align-items-center justify-content-center">
                        <p class="mb-1">{{ $t('OrderCurrent.modal.carInfo.width') }}(cm)</p>
                        <regular-input :fontSize="vw_fontSize" :value="selectedTrimDetails['width'] || 'NA'"
                          :disabled="true" type="text" :placeholder="$t('OrderCurrent.modal.carInfo.width')"
                          class="mx-2" :class="{ 'input--missing': isValidVin === true }" style="width: 60px" />
                      </div>
                      <p class="mt-3">x</p>
                      <!-- height -->
                      <div class="d-flex flex-column gap-2 align-items-center justify-content-center">
                        <p class="mb-1">{{ $t('OrderCurrent.modal.carInfo.height') }}(cm)</p>
                        <regular-input :fontSize="vw_fontSize" :value="selectedTrimDetails['height'] || 'NA'"
                          :disabled="true" type="text" :placeholder="$t('OrderCurrent.modal.carInfo.height')"
                          class="mx-2" :class="{ 'input--missing': isValidVin === true }" style="width: 60px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
            </div>

            <!-- DRY BOX PALLET LINE FORM -->
            <div v-if="isDryBox">
              <span>{{ $t('DryBox.order_number') }} <span class="text-danger">*</span></span>
              <regular-input :value="VIN" @input="VIN = $event" type="text"
                :placeholder="$t('DryBox.order_number')" class="form-group"
                :class="{ 'input--missing': VIN === '' }" />

              <div class="price-row">
                <div class="price-column">
                  <span>{{ $t('DryBox.length') }} <span class="text-danger">*</span></span>
                  <regular-input :value="MAKE" @input="MAKE = $event" type="number" min="0"
                    :placeholder="'0'" class="form-group" />
                </div>
                <div class="price-column">
                  <span>{{ $t('DryBox.width') }} <span class="text-danger">*</span></span>
                  <regular-input :value="MODEL" @input="MODEL = $event" type="number" min="0"
                    :placeholder="'0'" class="form-group" />
                </div>
                <div class="price-column">
                  <span>{{ $t('DryBox.height') }} <span class="text-danger">*</span></span>
                  <regular-input :value="TRIM" @input="TRIM = $event" type="number" min="0"
                    :placeholder="'0'" class="form-group" />
                </div>
                <div class="price-column">
                  <span>{{ $t('DryBox.qty') }} <span class="text-danger">*</span></span>
                  <regular-input :value="YEAR" @input="YEAR = $event" type="number" min="1"
                    :placeholder="'1'" class="form-group" />
                </div>
              </div>

              <div class="price-row">
                <div class="price-column">
                  <span>{{ $t('DryBox.unit_weight') }} <span class="text-danger">*</span></span>
                  <regular-input :value="REALWEIGHT" @input="REALWEIGHT = $event" type="number" min="0"
                    :placeholder="'0'" class="form-group" />
                </div>
                <div class="price-column">
                  <span>{{ $t('DryBox.line_weight') }}</span>
                  <regular-input :value="dryBoxLineWeight.toString()" :disabled="true" type="text"
                    :placeholder="'0'" class="form-group" />
                </div>
                <div class="price-column">
                  <span>{{ $t('DryBox.linear_feet') }}<span v-if="isDryBoxTwoWide"> ({{ $t('DryBox.two_wide') }})</span></span>
                  <regular-input :value="dryBoxLineLinearFeetPreview.toFixed(2)" :disabled="true" type="text"
                    :placeholder="'0'" class="form-group" />
                </div>
              </div>

              <regular-checkbox :id="'drybox-stackable-checkbox'" :checked="STACKABLE" @change="STACKABLE = $event"
                :label="$t('DryBox.stackable')" class="mb-2" />

              <div v-if="dryBoxStackTargets.length" class="form-group">
                <span>{{ $t('DryBox.stacked_on') }}</span>
                <regular-select :value="STACKED_ON" @change="STACKED_ON = $event" class="border form-group">
                  <option value="">{{ $t('DryBox.none') }}</option>
                  <option v-for="target in dryBoxStackTargets" :key="target.value" :value="target.value">
                    {{ target.label }}</option>
                </regular-select>
              </div>

              <p class="classification-error-text" v-if="!dryBoxLineCompleted">{{ $t('DryBox.required_fields') }}</p>
            </div>

            <div class="mt-4">
              <div class="my-2 kne-title">
                <h4>{{ $t('OrderCurrent.modal.carInfo.docOrDate') }}</h4>
              </div>
              <div class="document-date__container" :class="{ 'document-date__container--mobile': isScreenSmall }">
                <div class="document-date__item" :class="{ 'document-date__item--mobile mt-2': isScreenSmall }">
                  <date-pick v-model="order.dateSignataire" :displayFormat="'DD.MM.YYYY'" :hasInputElement="false"
                    :inputAttributes="{ readonly: true }" @input="removeOrderDocsUrl(); isZoneVerification ? calculateWarningLateTime() : calculateWLTime()"
                    :disabled="order.docs != ''" class="border ml-0">
                  </date-pick>
                  <div class="text-center">
                    <button class="btn mt-1 document-date__button-red border" @click="resetDate()"
                      :disabled="order.docs != ''">
                      <i class="fa fa-refresh" aria-hidden="true" /> {{ $t('OrderCurrent.modal.carInfo.date') }}
                    </button>
                    <button class="btn ml-3 mt-1 border" @click="setDateSignataire(); isZoneVerification ? calculateWarningLateTime() : calculateWLTime()"
                      :disabled="order.docs != ''">{{ $t('OrderCurrent.modal.carInfo.vehicleReady') }}</button>
                  </div>
                </div>
  
                <div class="document-date__item" :class="{ 'document-date__item--mobile mt-2': isScreenSmall }">
                  <custom-vue-dropzone ref="myVueDropzone" @dropzoneFile="updateDropzoneFile"
                    :allowed-file-types="allowedFileTypes" />
                </div>
              </div>
            </div>
  
            <!-- :disabled="order.dateSignataire === '' && order.docs === ''" -->
            <div class="m-2 mt-4">
              <button class="btn btn-kne-orange w-100 form-group" :disabled="!vehicleFormCompleted"
                @click="addVehicle()">{{ isDryBox ? $t('DryBox.add_line') : $t('OrderPending.vehicleInfoTab.add_vehicle') }}</button>
            </div>
          </div>
        </div>
  
        <!-- VEHICLE COUNTER -->
        <div class="card mb-2" :class="{ 'mx-2': !isScreenSmall }">
          <div class="table-responsive">
            <table v-if="isDryBox" class="table table-hover">
              <thead>
                <tr>
                  <th class="text-center">{{ $t('General.number') }}</th>
                  <th class="text-center">{{ $t('DryBox.order_number') }}</th>
                  <th class="text-center">{{ $t('DryBox.length') }}</th>
                  <th class="text-center">{{ $t('DryBox.width') }}</th>
                  <th class="text-center">{{ $t('DryBox.height') }}</th>
                  <th class="text-center">{{ $t('DryBox.qty') }}</th>
                  <th class="text-center">{{ $t('DryBox.unit_weight') }}</th>
                  <th class="text-center">{{ $t('DryBox.line_weight') }}</th>
                  <th class="text-center">{{ $t('DryBox.linear_feet') }}</th>
                  <th class="text-center">{{ $t('DryBox.stackable') }}</th>
                  <th class="text-center">{{ $t('DryBox.stacked_on') }}</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <transition-group name="fade" tag="tbody">
                <tr v-for="(line, index) in dryBoxLines" :key="index + line.vin">
                  <td class="text-center pt-3">{{ index + 1 }}</td>
                  <td class="text-center pt-3">{{ line.vin }}</td>
                  <td class="text-center pt-3">{{ line.make }}</td>
                  <td class="text-center pt-3">{{ line.model }}</td>
                  <td class="text-center pt-3">{{ line.trim }}</td>
                  <td class="text-center pt-3">{{ line.year }}</td>
                  <td class="text-center pt-3">{{ line.realWeight }}</td>
                  <td class="text-center pt-3">{{ line.weight }}</td>
                  <td class="text-center pt-3">{{ line.linearFeet.toFixed(2) }}</td>
                  <td class="text-center pt-3"><i v-if="line.stackable" class="fa fa-check" /></td>
                  <td class="text-center pt-3">{{ line.stackedOn ? '#' + line.stackedOn : '' }}</td>
                  <td class="text-center"> <button class="btn btn-kne-red icon-size w-100 py-1"
                      @click="onRemoveVehicle(vehicles[index], index)"><strong>&times;</strong></button> </td>
                </tr>
              </transition-group>
            </table>
            <table v-else class="table table-hover">
              <thead>
                <tr>
                  <th class="text-center">{{ $t('General.number') }}</th>
                  <th class="text-center">{{ $t('OrderPending.vehicleInfoTab.VIN') }}</th>
                  <th class="text-center">{{ $t('OrderPending.vehicleInfoTab.year') }}</th>
                  <th class="text-center">{{ $t('OrderPending.vehicleInfoTab.make') }}</th>
                  <th class="text-center">{{ $t('OrderPending.vehicleInfoTab.model') }}</th>
                  <th class="text-center">{{ $t('OrderPending.vehicleInfoTab.trim') }}</th>
                  <th class="text-center">{{ $t('OrderCurrent.modal.size') }}</th>
                  <th class="text-center">{{ 'Curb Weight(lbs)' }}</th>
                  <th class="text-center">{{ $t('OrderCurrent.modal.documents') }}</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <transition-group name="fade" tag="tbody">
                <tr v-for="(vehicle, index) in vehicles" :key="index + vehicle.vin + vehicle.year">
                  <td class="text-center pt-3">{{ index + 1 }}</td>
                  <td class="text-center pt-3">{{ vehicle.vin }}</td>
                  <td class="text-center pt-3">{{ vehicle.year }}</td>
                  <td class="text-center pt-3">{{ vehicle.make }}</td>
                  <td class="text-center pt-3">{{ vehicle.model }}</td>
                  <td class="text-center pt-3">{{ vehicle.trim }}</td>
                  <td class="text-center pt-3">{{ getStringVehicleSize(vehicle.size) }}</td>
                  <td class="text-center pt-3">{{ vehicle.weight }}</td>
                  <td class="text-center pt-3" v-if="vehicle.dateSignataire">{{ vehicle.dateSignataire }}</td>
                  <td class="text-center pt-3" v-if="vehicle.docs"><i class="fa fa-check ml-2" /></td>
                  <td class="text-center"> <button class="btn btn-kne-red icon-size w-100 py-1"
                      @click="onRemoveVehicle(vehicle, index)"><strong>&times;</strong></button> </td>
                </tr>
              </transition-group>
            </table>
          </div>
        </div>

        <!-- DRY BOX LOAD SUMMARY -->
        <div v-if="isDryBox" class="mx-2 mt-3">
          <h4 class="kne-title">{{ $t('DryBox.summary') }}</h4>
          <div class="price-row">
            <div class="price-column">
              <span>{{ $t('DryBox.trailer') }}</span>
              <regular-select :value="selectedTrailerId" @change="selectedTrailerId = $event"
                class="border form-group">
                <option v-for="trailer in dryBoxTrailerOptions" :key="trailer.id" :value="trailer.id">
                  {{ trailer.label }}</option>
              </regular-select>
            </div>
          </div>
          <div v-if="vehicles.length" class="order-total-summary">
            <div class="order-total-summary__row">
              <span>{{ $t('DryBox.linear_feet') }}</span>
              <strong>{{ dryBoxTotals.linearFeet.toFixed(2) }}</strong>
            </div>
            <div class="order-total-summary__row">
              <span>{{ $t('DryBox.total_weight') }}</span>
              <strong>{{ dryBoxTotals.weight }}</strong>
            </div>
            <div class="order-total-summary__row">
              <span>{{ $t('DryBox.capacity') }}</span>
              <strong>{{ dryBoxTotals.capacityPercent.toFixed(1) }}%</strong>
            </div>
            <div class="order-total-summary__row">
              <span>{{ $t('DryBox.load_status') }}</span>
              <strong>{{ dryBoxLoadStatusLabel }}</strong>
            </div>
            <div class="order-total-summary__row">
              <span>{{ $t('DryBox.total_price') }}</span>
              <strong>{{ formatModalMoney(dryBoxTotals.price) }}$</strong>
            </div>
            <div class="order-total-summary__row">
              <span>{{ $t('DryBox.price_per_linear_foot') }}</span>
              <strong>{{ formatModalMoney(dryBoxTotals.pricePerLinearFoot) }}$</strong>
            </div>
            <div class="order-total-summary__row">
              <span>{{ $t('DryBox.price_per_lb') }}</span>
              <strong>{{ formatModalMoney(dryBoxTotals.pricePerLb) }}$</strong>
            </div>
          </div>
          <p class="classification-error-text mb-1" v-for="(alert, alertIndex) in dryBoxAlerts" :key="alertIndex">
            <i class="fa fa-exclamation-triangle" /> {{ alert }}</p>
        </div>

        <!-- Warning and Late Time Section -->
        <div class="mx-2 mt-3">
            <div class="price-row">
              <div class="price-column">
                <span>
                  Warning Time <span class="text-danger">*</span> 
                  <hover-tool-tip class="mx-2" :clickable="false" :text="$t('OrderCurrent.modal.warningTimeMessage')" top right />
                </span>
                <regular-input :value="warningTime" @input="isZoneVerification ? warningTime = $event : calculateWLTime(warningTime = $event)" :disabled="isZoneVerification" :placeholder="'0'"
                  class="form-group" min="0" />
              </div>
              <div class="price-column">
                <span>
                  Late Time <span class="text-danger">*</span>
                  <hover-tool-tip class="mx-2" :clickable="false" :text="$t('OrderCurrent.modal.lateTimeMessage')" top right />
                </span>
                <regular-input :value="lateTime" @input="isZoneVerification ? lateTime = $event : calculateWLTime(lateTime = $event)" :disabled="isZoneVerification" :placeholder="'0'"
                  class="form-group" min="0" />
              </div>
            </div>
            <p v-show="isZoneVerification && order.transmitterZoneId && order.receiverZoneId && (vehicles.length || order.dateSignataire) && (!this.warningTime || !this.lateTime)" class="mb-2 text-danger">
              {{ $t('OrderCurrent.modal.no_warning_late_time') }}
              <span style="text-decoration: underline; cursor: pointer;" @click="openModal(transmitterZone)">
                {{ $t('OrderCurrent.modal.configureZonePrice') }}
              </span>
            </p>
          </div>

        <!-- PRICING -->
        <div class="mx-2 mt-4" id="Pricing">
          <zone-pricing-modal v-if="showZoneModal" :zone="transmitterZone" :toZone="order.receiverZoneId"
            @closeModal="closeModal"></zone-pricing-modal>
          <discount-zone-pricing-modal v-if="showDealerZoneModal" :zone="transmitterZone" :toZone="order.receiverZoneId"
            :discountedZones="billingDealer.discountedZones || []" :accountName="billingDealer.name"
            :accountId="order.payer" @closeModal="closeModal"></discount-zone-pricing-modal>
          <h4 class="kne-title">{{ $t('OrderCurrent.modal.pricing') }}</h4>

          <div class="price-row">
            <div class="price-column fuel-charge-control">
              <span>{{ $t('OrderCurrent.modal.fuel_charge_percent') }}</span>
              <regular-input
                min="0"
                :value="fuelChargeInputValue"
                @input="onFuelChargeInput"
                type="number"
                :disabled="isFuelChargeIncluded"
                :placeholder="$t('OrderCurrent.modal.fuel_charge_percent_placeholder')"
                class="form-group" />
              <regular-checkbox :id="'fuelCharge-checkbox'" :checked="isFuelChargeIncluded" @change="toggleFuelCharge"
                :label="$t('OrderCurrent.modal.fuel_charge_included')" class="fuel-charge-control__checkbox" />
            </div>
          </div>

          <!-- DRY BOX FULL LOAD -->
          <div v-if="isDryBox" class="mt-3">
            <regular-checkbox :id="'full-load-checkbox'" :checked="isFullLoad" @change="isFullLoad = $event"
              :label="$t('DryBox.full_load')" class="mb-2" />
            <div v-if="isFullLoad" class="price-row">
              <div class="price-column">
                <span>{{ $t('DryBox.flat_price') }}</span>
                <regular-input :value="fullLoadPrice" @input="fullLoadPrice = $event" type="number" min="0"
                  :placeholder="'0'" class="form-group" />
              </div>
              <div class="price-column">
                <span>{{ $t('DryBox.mileage') }}</span>
                <regular-input :value="fullLoadMileage" @input="fullLoadMileage = $event" type="number" min="0"
                  :placeholder="'0'" class="form-group" />
              </div>
              <div class="price-column">
                <span>{{ $t('DryBox.rate_per_mile') }}</span>
                <regular-input-number :value="formatModalMoney(fullLoadRatePerMile)" :disabled="true"
                  :placeholder="'0'" class="form-group" />
              </div>
              <div class="price-column">
                <span>&nbsp;</span>
                <button class="btn btn-kne-orange w-100" :disabled="!vehicles.length || !Number(fullLoadPrice)"
                  @click="applyFullLoadPrice">{{ $t('DryBox.apply_to_lines') }}</button>
              </div>
            </div>
          </div>

          <!-- SPLIT PRICING  -->
          <div v-if="vehicles.length >= 2" class="split-load-control mt-4">
            <label for="splitLoadPrice">
              {{$t('OrderCurrent.modal.splitLoad.splitLoadPrice')}}
              <hover-tool-tip class="mx-2" :clickable="false" :text="$t('OrderCurrent.modal.splitLoad.splitPriceTooltip')" top right />
            </label>
            <regular-input
              min="0"
              v-model="splitLoadPrice"
              type="number"
              placeholder="Load Price"
            />
            <button class="mt-1 btn btn-kne-orange" @click="applySplitLoad">{{$t('OrderCurrent.modal.splitLoad.applyAll')}}</button>
          </div>

          <!-- Individual Vehicle Pricing Section -->
          <div v-for="(vehicle, index) in vehicles" :key="index" class="mt-3">
            <h5>{{ getVehiclePricingLabel(vehicle, index) }}</h5>
            <div class="price-row">
              <div class="price-column">
                <span>{{ $t('OrderCurrent.modal.regularPrice') }} ($) <span class="text-danger">*</span></span>
                <regular-input :value="isZoneVerification ? order.regularPrice : vehicle.regularPrice" :disabled="isZoneVerification"
                  @input="isZoneVerification ? calculatePrice(order.regularPrice = $event, index) : calculateCarPrice(vehicles[index].regularPrice = $event, index)" :placeholder="'0'"
                  class="form-group" min="100" />
                  <p v-if="isZoneVerification && order.transmitterZoneId && order.receiverZoneId && !order.regularPrice" class="mb-2 text-danger">
                    {{ $t('OrderCurrent.modal.noPriceErrorMessage') }}
                    <span style="text-decoration: underline; cursor: pointer;" @click="openModal(transmitterZone, index)">
                      {{ $t('OrderCurrent.modal.configureZonePrice') }}
                    </span>
                  </p>
              </div>
              <div class="price-column">
                <span>{{$t('OrderCurrent.modal.discount')}} ({{ vehicle.discountAmountType }})</span>
                <div class="input-with-buttons">
                  <regular-input :value="vehicle.discount" type="number"
                    @input="calculateCarPrice(vehicle.discount = $event, index)" :placeholder="'0'" class="form-group" min="0" />
                    <div class="button-group">
                      <button class="w-btn n-b-r" :class="{ 'selected': vehicle.discountAmountType === '$' }"
                        @click="selectDiscountAmountType('$', index)">$</button>
                      <button class="w-btn" :class="{ 'selected': vehicle.discountAmountType === '%' }"
                        @click="selectDiscountAmountType('%', index)">%</button>
                    </div>
                </div>
              </div>
              <div class="price-column">
                <span>{{$t('OrderCurrent.modal.surplus')}} ({{ vehicle.surplusAmountType }})</span>
                <div class="input-with-buttons">
                  <regular-input :value="vehicle.surplus" type="number"
                    @input="calculateCarPrice(vehicle.surplus = $event, index)" :placeholder="'0'" class="form-group" min="0" />
                    <div class="button-group">
                      <button class="w-btn n-b-r" :class="{ 'selected': vehicle.surplusAmountType === '$' }"
                        @click="selectSurplusAmountType('$',  index)">$</button>
                      <button class="w-btn" :class="{ 'selected': vehicle.surplusAmountType === '%' }"
                        @click="selectSurplusAmountType('%', index)">%</button>
                    </div>
                </div>
              </div>
              <div v-if="!isDryBox" class="price-column">
                <span>{{$t('OrderCurrent.modal.surplus')}} (by Weight)</span>
                <div class="input-with-buttons">
                  <regular-input :disabled="isFromMarketplace" :value="vehicle.surplusByCategory" type="number"
                    @input="calculateCarPrice(vehicle.surplusByCategory = $event, index)" :placeholder="'0'" class="form-group" min="0" />
                </div>
              </div>
              <div class="price-column">
                <span>{{ $t('OrderPending.orderTab.price') }} ($)</span>
                <regular-input-number :value="isFromMarketplace ? order.regularPrice : vehicles[index].price" :disabled="true" :placeholder="'0'" class="form-group" />
              </div>
              <div class="price-column">
                <span>{{ $t('OrderCurrent.modal.fuel_charge_amount') }} ($)</span>
                <regular-input-number :value="formatModalMoney(getVehicleFuelChargeAmount(vehicle))" :disabled="true" :placeholder="'0'" class="form-group" />
              </div>
              <div class="price-column">
                <span>{{ $t('OrderCurrent.modal.bill_total') }} ($)</span>
                <regular-input-number :value="formatModalMoney(getVehicleBillTotal(vehicle))" :disabled="true" :placeholder="'0'" class="form-group" />
              </div>
            </div>
            <div v-if="Number(vehicle.surplus) || Number(vehicle.discount)" class="price-column">
              <span>{{ $t('OrderCurrent.modal.surplusRebateNote') }}<span class="text-danger">*</span></span>
              <regular-input :disabled="isFromMarketplace" :value="vehicle.surplusRebateNote" type="text"
                    @input="vehicle.surplusRebateNote = $event; verifySurplusRebate()" class="form-group"/>
            </div>
          </div>
          <div>
            <FeeSelector 
              :initialFees="order.fees"
              @fees-updated="handleFeesUpdate"
            />
          </div>
          <div v-if="vehicles.length" class="order-total-summary">
            <div class="order-total-summary__row">
              <span>{{ $t('OrderCurrent.modal.orders_subtotal') }}</span>
              <strong>{{ formatModalMoney(vehiclesSubtotal) }}$</strong>
            </div>
            <div class="order-total-summary__row">
              <span>{{ $t('OrderCurrent.modal.fuel_charge_amount') }}</span>
              <strong>{{ formatModalMoney(vehiclesFuelChargeTotal) }}$</strong>
            </div>
            <div v-if="createdOrdersFeesTotal" class="order-total-summary__row">
              <span>{{ $t('OrderCurrent.modal.fees_total') }}</span>
              <strong>{{ formatModalMoney(createdOrdersFeesTotal) }}$</strong>
            </div>
            <div class="order-total-summary__row order-total-summary__row--total">
              <span>{{ $t('OrderCurrent.modal.all_orders_total') }}</span>
              <strong>{{ formatModalMoney(allOrdersBillTotal) }}$</strong>
            </div>
          </div>
          <p v-if="order.billingComment" class="brown_text"><i class="fa fa-file-invoice-dollar"></i> {{ order.billingComment }}</p>
          <button class="btn btn-kne-green mb-2" v-if="order.regularPrice"
            @click="openModal(transmitterZone, index)">
              {{ $t('OrderCurrent.modal.editZoneToZonePrice') }}
          </button>
          <p v-if="order.regularPrice" class="yellow_text">{{ $t('OrderCurrent.modal.zonePriceUpdateWarn') }}</p>
        </div>
        <!-- Pricing END -->
        <!-- <div>
           <button
             v-if="order.transmitterName && order.receiverName && companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b'"
             class="btn btn-kne-orange w-100 form-group"
             @click="validatePricing(order.transmitterPostcode.substr(0, 3) + '-' + order.receiverPostcode.substr(0, 3))">
             {{$t('OrderPending.vehicleInfoTab.validate')}}
           </button>
         </div> -->
  
        <!-- PRICE COUNTER -->
        <!-- <div class="col-12 card">
           <div class="table-responsive">
             <table class="table table-hover">
               <thead>
               <tr>
                 <th>{{$t('General.number')}}</th>
                 <th>{{$t('OrderCurrent.modal.regularPrice')}}</th>
                 <th>{{$t('OrderCurrent.modal.discount')}}</th>
                 <th>{{$t('OrderCurrent.modal.surplus')}}</th>
                 <th>{{$t('OrderCurrent.billing')}}</th>
                 <th>{{$t('OrderCurrent.modal.estimatedDelay')}}</th>
                 <th>{{$t('OrderCurrent.modal.delay')}}</th>
                 <th>{{$t('OrderCurrent.modal.vehicles')}}</th>
                 <th>{{$t('OrderCurrent.modal.count')}}</th>
               </tr>
               </thead>
               <transition-group name="fade" tag="tbody">
                 <tr v-for="(vehicle, index) in pricingAndDelay" :key="vehicle.pricing + index">
                   <td>{{index}}</td>
                   <td>{{vehicle.price}}$</td>
                   <td>{{vehicle.discount}}$</td>
                   <td>{{vehicle.surplus}}$</td>
                   <td>{{vehicle.payerName}}</td>
                   <td>{{vehicle.dateExpected}}</td>
                   <td>{{vehicle.delay}}</td>
                   <td>{{vehicle.makeModelYear}}</td>
                   <td>{{vehicle.count}}</td>
                 </tr>
               </transition-group>
             </table>
           </div>
         </div> -->
  
        <div class="col-12 mt-3">
          <button class="btn btn-kne-orange w-100 mb-2" :disabled="!formCompleted"
            @click="isPendingOrder || isFromMarketplace ? approveOrder() : addOrder()">
            {{ isPendingOrder || isFromMarketplace ? $t('OrderPending.approveOrder') : $t('OrderPending.submitOrder') }}
          </button>
        </div>
  
      </div>

    </modal>

  </div>
  
</template>

<script>
import { db } from '../../../../firebase'
import Modal from '../../interface-components/Modal.vue'
import RegularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import RegularTextarea from '../../basic-components/regularTextarea.vue'
import regularInput from '../../basic-components/regularInput.vue'
import regularInputNumber from '../../basic-components/regularInputNumber.vue'
import RegularSelect from '../../basic-components/regularSelect.vue'

import ToggleSwitch from '../../special-components/Other-components/ToggleSwitch.vue'
import hoverToolTip from '../../basic-components/hoverToolTip.vue'
import DeliveryLocationDetails from '../Other-components/DeliveryLocationDetails.vue'
import CustomVueDropzone from '../Custom-packages/Custom-VueDropzone.vue'
import ZonePricingModal from './ZonePricing-modal.vue'
import {point as turfPoint, polygon as turfPolygon, booleanPointInPolygon} from '@turf/turf'

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import RegularCheckbox from '../../basic-components/regularCheckbox.vue'
import {
isCustomVINValid,
isCustomYearValid
} from '../../../../utils/newOrder-modal'
import { isRegularOrder } from '../../../../inventory/inventorySelectors'
import DiscountZonePricingModal from './DiscountZonePricing-modal.vue'
import NewZoneModal from './newZone-modal.vue'
import FeeSelector from '../../basic-components/feeSelector.vue'
import { dryBoxMixin } from '../../../../utils/dryBoxLabels'
import { getRealName } from '../../../../utils/orderIdentity'
import {
  TRAILER_TYPES,
  DEFAULT_TRAILER_ID,
  STACKED_MAX_COMBINED_WEIGHT_LBS,
  MAX_AVG_WEIGHT_PER_LINEAR_FOOT_LBS,
  LOAD_STATUS,
  isTwoWide,
  lineTotalWeight,
  lineLinearFeet,
  capacityPercent,
  loadStatusFromPercent
} from '../../../../constants/dryBox'

// makeModels/<year> → { make: { model: { trim: [...] } } }, fetched one year at a time and kept
// outside Vue reactivity (binding the whole node made ~60k reactive values on every modal open)
const makeModelsByYear = {}
const loadMakeModels = (year) => {
  if (!year) return Promise.resolve({})
  if (!makeModelsByYear[year]) {
    makeModelsByYear[year] = db.ref('makeModels').child(String(year)).once('value')
      .then(snapshot => snapshot.val() || {})
      .catch((error) => {
        delete makeModelsByYear[year]
        console.error('Unable to load makeModels for', year, error)
        return {}
      })
  }
  return makeModelsByYear[year]
}

export default {
  name: 'NewOrderModal',

  components: {
    RegularDatalistDriver,
    RegularTextarea,
    regularInput,
    regularInputNumber,
    RegularCheckbox,
    RegularSelect,
    hoverToolTip,
    DeliveryLocationDetails,
    vueDropzone: vue2Dropzone,
    FeeSelector,
    DatePick,
    Modal,
    CustomVueDropzone,
    ZonePricingModal,
    DiscountZonePricingModal,
    ToggleSwitch,
    NewZoneModal
  },

  mixins: [dryBoxMixin],

  async created () {
    await this.resolveCurrentOperatorName()
    if (!this.isDryBox) {
      await this.getVehiclePriceByClassification()
    }
    if (!Array.isArray(this.order.fees)) {
      this.order.fees = []
    }
  },

  data () {
    return {
      isLoading: true,
      searchedVin: [],
      billingType: '',
      billingLatLong: {lat: null, long: null},
      showNewZoneModal: false,
      splitLoadPrice: 0,
      transmitterZone: {},
      VIN: '',
      vinError: '',
      YEAR: '',
      yearError: '',
      MAKE: '',
      MODEL: '',
      TRIM: '',
      trimOptions: [],
      matchedVins: [],
      notFoundVins: [],
      selectedTrimDetails: {},
      showVolumetricWeightDetails: false,
      classificationMessage: null,
      SIZE: '',
      WEIGHT: '',
      REALWEIGHT: '',
      STACKABLE: false,
      STACKED_ON: '',
      selectedTrailerId: DEFAULT_TRAILER_ID,
      isFullLoad: false,
      fullLoadPrice: '',
      fullLoadMileage: '',
      weightError: '',
      isValidVin: false,
      isVinCustom: false,
      showZoneModal: false,
      showDealerZoneModal: false,
      showClassificationMessageType: null,
      vw_fontSize: 14,
      validateBtnDisabled: false,
      vinErrorMsg: '',
      vehicles: [],
      transmitterEmailList: [],
      receiverEmailList: [],
      selectedContactEmails: [],
      pricingAndDelay: [],
      years: [],
      sizeTooltipText: '',
      sizeTooltipColor: '',
      allowedFileTypes: ['.pdf', '.jpg', '.png', '.doc', '.docx', '.htm'],
      billingDealer: {},
      discountedZones: [],
      warningTime: 0,
      lateTime: 0,
      dateTemporary: '',
      openSearchVins: false,
      orderFees: [
        {
          text: this.$t('OrderPending.orderTab.storageFee'),
          value: 'Storage Fee'
        },
        {
          text: this.$t('OrderPending.orderTab.waitingTime'),
          value: 'Waiting Fee'
        },
        {
          text: this.$t('OrderPending.orderTab.dryRun'),
          value: 'Dry Run'
        },
        {
          text: this.$t('OrderPending.orderTab.other'),
          value: 'Other'
        }
      ],
      buttonList: {
        extra_heavy: {
          id: 5,
          label: this.$t('OrderCurrent.modal.extra_heavy'),
          value: 'Extra heavy',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84)'
        },
        heavy: {
          id: 4,
          label: this.$t('OrderCurrent.modal.heavy'),
          value: 'Heavy',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84)'
        },
        medium: {
          id: 3,
          label: this.$t('OrderCurrent.modal.medium'),
          value: 'Medium',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84)'
        },
        light: {
          id: 2,
          label: this.$t('OrderCurrent.modal.light'),
          value: 'Light',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84)'
        },
        not_standard: {
          id: 1,
          label: this.$t('OrderCurrent.modal.not_standard'),
          value: 'Not Standard',
          selected: true,
          selectedBgColor: 'rgb(255, 178, 84)'
        }
      },
      isModelSelected: false,
      isTrimSelected: false,
      zones: [],
      isConflictingZones: false,
      priceByVehicleClassification: {
        light: {surplus: 0},
        medium: {surplus: 0},
        heavy: {surplus: 0},
        extra_heavy: {suplus: 0},
        not_standard: {suplus: 0}
      },
      currentOperatorName: '',
      logisticsContactSelectionValid: true,
      formCompleted: false
    }
  },

  props: {
    isNewOrderModal: Boolean,
    order: Object,
    addressbook: Array,
    isPendingOrder: {
      required: false,
      default: false,
      type: Boolean
    },
    vinsList: {
      required: false,
      default: () => [],
      type: Array
    },
    isFromMarketplace: {
      required: false,
      default: false,
      type: Boolean
    },
    zoneData: Object
  },

  methods: {
    async resolveCurrentOperatorName () {
      const userInfo = this.$store.state.userInfo || {}
      const hasFirstName = (typeof userInfo.firstName !== 'undefined' && userInfo.firstName !== '')
      const hasLastName = (typeof userInfo.lastName !== 'undefined' && userInfo.lastName !== '')

      if (hasFirstName || hasLastName) {
        this.currentOperatorName = `${userInfo.firstName || ''} ${userInfo.lastName || ''}`.trim()
        return
      }

      if (this.companyUID && this.uid) {
        try {
          const employeeSnapshot = await db.ref(`database/transporter/${this.companyUID}/user/employees/${this.uid}/infos`).once('value')
          if (employeeSnapshot.exists()) {
            const employee = employeeSnapshot.val() || {}
            const employeeName = `${employee.firstName || ''} ${employee.lastName || ''}`.trim()
            this.currentOperatorName = employeeName || employee.name || ''
          }
        } catch (error) {
          console.log('Unable to resolve current operator name', error)
        }
      }
    },

    setNoteName () {
      const user = this.$store.state.userInfo
      const isFirstNameValid = (typeof user.firstName !== 'undefined' && user.firstName !== '')
      const isLastNameValid = (typeof user.lastName !== 'undefined' && user.lastName !== '')

      if (this.currentOperatorName) return this.currentOperatorName
      if (!isFirstNameValid || !isLastNameValid) return user.name
      else return `${user.firstName} ${user.lastName}`
    },
    formatNotePrice (price) {
      const parsedPrice = Number(price)
      if (isNaN(parsedPrice)) return '0.00$'
      return `${parsedPrice.toFixed(2)}$`
    },
    buildCreationPriceNoteText (actionLabel, payerName, price) {
      return `${actionLabel} - ${payerName} - ${this.formatNotePrice(price)}`
    },
    normalizeMoneyValue (value) {
      const amount = Number(value)
      return isNaN(amount) ? 0 : amount
    },
    formatModalMoney (value) {
      return this.normalizeMoneyValue(value).toFixed(2)
    },
    shouldApplyFuelCharge () {
      return !this.isFuelChargeIncluded
    },
    getVehicleBasePrice (vehicle) {
      return this.isFromMarketplace ? this.normalizeMoneyValue(this.order.regularPrice) : this.normalizeMoneyValue(vehicle.price)
    },
    getVehicleFuelChargeAmount (vehicle) {
      if (!this.shouldApplyFuelCharge()) return 0
      return (this.getVehicleBasePrice(vehicle) * this.normalizeMoneyValue(this.order.fuelCharge)) / 100
    },
    getVehicleBillTotal (vehicle) {
      return this.getVehicleBasePrice(vehicle) + this.getVehicleFuelChargeAmount(vehicle)
    },
    async initializeModal () {
        await this.getZones()
        this.$set(this.order, 'discountAmountType', '%')
        this.$set(this.order, 'surplusAmountType', '%')
        this.initializeFuelCharge()
        await this.initializeVehicleDetails()
        if (!this.isDryBox) {
          await this.calculatePrice(this.order, 0)
          await this.getVehiclePriceByClassification()
        }
    },
    setBillingType (value) {
      this.billingType = value
    },
     toggleZoneModal (value) {
      this.showNewZoneModal = true
      this.setBillingType(value)
    },
    onSageSelected () {
      this.formCompleted = this.isFormCompleted()
    },
    onFuelChargeIncluded (value) {
      this.$set(this.order, 'includedFuelCharge', value)
      this.$set(this.order, 'applyFuelCharge', !value)
    },
    handleFeesUpdate (fees) {
      this.order.fees = fees
    },
    getCompanyFuelCharge () {
      const userInfo = this.$store.state.userInfo || {}
      return userInfo.fuelCharge !== undefined && userInfo.fuelCharge !== null && userInfo.fuelCharge !== ''
        ? userInfo.fuelCharge
        : 0
    },
    getClientFuelCharge (client) {
      return client && client.fuelCharge !== undefined && client.fuelCharge !== null && client.fuelCharge !== ''
        ? client.fuelCharge
        : this.getCompanyFuelCharge()
    },
    getDefaultFuelCharge () {
      return this.getClientFuelCharge(this.billingDealer)
    },
    hasFuelChargeValue (value) {
      return value !== undefined && value !== null && value !== ''
    },
    applyBillingAccountSettings (client) {
      if (!client) return

      const applyFuelCharge = client.applyFuelCharge !== undefined ? client.applyFuelCharge : true
      this.$set(this.order, 'applyFuelCharge', applyFuelCharge)
      this.$set(this.order, 'includedFuelCharge', applyFuelCharge === false)
      this.$set(this.order, 'fuelCharge', this.getClientFuelCharge(client))
      this.$set(this.order, 'billingComment', client.billingComment || '')
      this.$set(this.order, 'payerOdooPartnerId', client.odooPartnerId || '')
      this.$set(this.order, 'payerOdooPartnerName', client.odooPartnerName || '')
      this.$set(this.order, 'zeroTax', client.zeroTax === true)
      if (client.sageID !== undefined) {
        this.$set(this.order, 'sageID', client.sageID || '')
      }
    },
    initializeFuelCharge () {
      if (!this.hasFuelChargeValue(this.order.fuelCharge) || (!this.isPendingOrder && !this.isFromMarketplace && Number(this.order.fuelCharge) === 0)) {
        this.$set(this.order, 'fuelCharge', this.getCompanyFuelCharge())
      }
      if (this.order.includedFuelCharge === undefined) {
        this.$set(this.order, 'includedFuelCharge', this.order.applyFuelCharge === false)
      }
      if (this.order.applyFuelCharge === undefined || this.order.applyFuelCharge === '') {
        this.$set(this.order, 'applyFuelCharge', !this.order.includedFuelCharge)
      }
    },
    onFuelChargeInput (value) {
      this.$set(this.order, 'fuelCharge', value)
      if (value !== '') {
        this.$set(this.order, 'includedFuelCharge', false)
        this.$set(this.order, 'applyFuelCharge', true)
      }
    },
    closeZoneModal (billingType) {
      // Update billing data
      this.$refs.delivLocDetails.initialize()
      if (billingType === 'BILLING') {
        this.$refs.delivLocDetails.refreshBillingData()
      } else if ((billingType === 'PICKUP')) {
        // Update transmitter/pickup data
        this.$refs.delivLocDetails.refreshTranmitterData()
      } else {
        // Update receiver/delivery data
        this.$refs.delivLocDetails.refreshReceiverData()
      }
      this.handleZoneUpdate()
      this.showNewZoneModal = false
    },
    async getVehiclePriceByClassification () {
      db.ref('users').child('transporters').child(this.companyUID).child('priceByVehicleClassification').once('value').then((snapshot) => {
        this.priceByVehicleClassification = snapshot.val() || this.priceByVehicleClassification
      })
    },
    toggleClassificationMessageType (type, message) {
      if (type === null) {
        this.showClassificationMessageType = null
        this.classificationMessage = null
      } else {
        this.showClassificationMessageType = type
        this.classificationMessage = message
      }
    },
    /** Sets the proper text depending on if a size is found or not */
    setSizeTooltipText (isTruthy) {
      if (isTruthy) {
        const classification = this.calculateVehicleClassification(this.WEIGHT)
        const thresholds = this.getClassificationThresholds()
        // const range = thresholds[classification] || {}
        const readableSize = this.getStringVehicleSize(this.SIZE)

        let chartText = `${this.$t('Vehicle.size_found')} (${readableSize}).\n`
        // chartText += `${this.$t('Vehicle.weight_range_used')}: ${range.lowerLimit} - ${range.upperLimit}g \n\n`
        chartText += `${this.$t('Vehicle.all_weight_ranges')}:\n`

        for (const [key, r] of Object.entries(thresholds)) {
          const isCurrent = key === classification
          const label = `${this.$t('Vehicles.' + key)}`
          const line = `${label}: ${r.lowerLimit} - ${r.upperLimit} lbs,`
          chartText += isCurrent ? `${line}\n` : `  ${line}\n`
        }

        this.sizeTooltipText = chartText.trim()
        this.sizeTooltipColor = 'green'
      } else {
        this.sizeTooltipText = this.$t('Vehicle.size_not_found')
        this.sizeTooltipColor = 'red'
      }
    },

    getStringVehicleSize (size) {
      if (size === '') size = 1
      let text = ''
      const keys = Object.keys(this.buttonList)

      text = keys.find(key => this.buttonList[key].id.toString() === size.toString())
      text = this.buttonList[text].label

      return text
    },

    getVehiclePricingLabel (vehicle, index) {
      if (this.isDryBox) {
        return `${this.$t('DryBox.line')} ${index + 1} — ${vehicle.vin}`
      }
      return (vehicle.make) + ' ' + vehicle.model + ' ' + vehicle.trim || `Vehicle ${index + 1}`
    },

    applyFullLoadPrice () {
      this.splitLoadPrice = this.fullLoadPrice
      this.applySplitLoad()
    },

    applySplitLoad () {
      if (!this.vehicles.length) return

      const splitPrice = this.normalizeMoneyValue(this.splitLoadPrice) / this.vehicles.length
      const formattedSplitPrice = this.formatModalMoney(splitPrice)

      this.vehicles.forEach(vehicle => {
        vehicle.regularPrice = formattedSplitPrice
        vehicle.discount = 0
        vehicle.discountAmountType = '%'
        vehicle.surplus = 0
        vehicle.surplusAmountType = '%'
        vehicle.price = formattedSplitPrice
        vehicle.surplusByCategory = 0
      })
    },

    vinValidator (value) {
      this.VIN = value
      if (isCustomVINValid(value)) {
        this.vinError = ''
      } else {
        this.vinError = 'Invalid VIN'
      }
    },

    yearValidator (value) {
      this.YEAR = value
    if (isCustomYearValid(value)) {
    this.yearError = ''
    } else {
    this.yearError = 'Invalid Year'
    }
    },

    async initializeVehicleDetails () {
      const isDryBoxRecord = this.isDryBox || this.order.isDryBoxOrder === true
      if (this.order.vin) {
        if (isDryBoxRecord) {
          this.VIN = this.order.vin
          this.MAKE = this.order.make || ''
          this.MODEL = this.order.model || ''
          this.TRIM = this.order.trim || ''
          this.YEAR = this.order.year || ''
          this.REALWEIGHT = this.order.realWeight || ''
          this.STACKABLE = this.order.stackable === true
          this.STACKED_ON = this.order.stackedOn || ''
          if (this.order.trailerType && TRAILER_TYPES[this.order.trailerType]) {
            this.selectedTrailerId = this.order.trailerType
          }
          this.isFullLoad = this.order.isFullLoad === true
          this.fullLoadPrice = this.order.fullLoadTotalPrice || ''
          this.fullLoadMileage = this.order.fullLoadMileage || ''
        } else {
          this.VIN = this.order.vin
          this.MAKE = this.order.make
          this.MODEL = this.order.model
          this.YEAR = this.order.year
          await this.validateVIN(this.VIN)
        }
      }
      if (this.order.payer) {
        await this.getSelectedDealer()
      }

      if (this.order.dateSignataire) {
        this.calculateWarningLateTime()
      }
      if (this.TRIM && !isDryBoxRecord) {
        await this.onSubmitCarTrim(this.TRIM)
      }
      if (this.vehicleFormCompleted || (this.isFromMarketplace || this.isPendingOrder)) {
        this.addVehicle()
      }
      if (this.isPendingOrder) {
        this.order.notes = []
        const note = {
          date: Date.now(),
          name: this.setNoteName(),
          text: this.buildCreationPriceNoteText('ORDER ACCEPTED', getRealName(this.order, 'payer'), this.order.price)
        }
        this.order.notes.push(note)
      }
    },

    findCategoryByWeight (weight, classifications, isVolumetric = true) {
      let typeKey = null
      Object.keys(classifications).forEach(key => {
        const classification = classifications[key]

        let lower, upper
        if (!isVolumetric) {
          lower = classification.realLower
          upper = classification.realUpper
        } else if (isVolumetric) {
          lower = classification.volumetricLower
          upper = classification.volumetricUpper
        }
        if (weight >= Number(lower) && weight <= Number(upper)) {
          typeKey = key
        }
      })
      return typeKey
    },
    // Button: Add Vehicle
    addVehicle: function () {
      if (this.isDryBox) {
        this.vehicles.push({
          vin: this.VIN.trim(),
          make: this.MAKE.toString(),
          model: this.MODEL.toString(),
          trim: this.TRIM.toString(),
          year: this.YEAR.toString(),
          weight: this.dryBoxLineWeight.toString(),
          realWeight: this.REALWEIGHT.toString(),
          size: '',
          stackable: this.STACKABLE === true,
          stackedOn: this.STACKED_ON || '',
          docs: this.order.docs,
          dateSignataire: this.order.dateSignataire,
          signataire: this.userInfo.name,
          surplusRebateNote: '',
          regularPrice: 0,
          discount: 0,
          discountAmountType: '%',
          surplus: 0,
          surplusAmountType: '%',
          price: 0,
          surplusByCategory: 0
        })
        if (this.isPendingOrder) {
          this.order.realWeight = this.REALWEIGHT
        }
        this.dateTemporary = this.order.dateSignataire ? this.order.dateSignataire : Date.now()
        this.clearDryBoxLineForm()
        return
      }
      const realWeight = Number(this.REALWEIGHT)
      const volumetricWeight = Number(this.WEIGHT)

      const realType = this.findCategoryByWeight(realWeight, this.priceByVehicleClassification, false)
      const volumetricType = this.findCategoryByWeight(volumetricWeight, this.priceByVehicleClassification, true)

      let vehicleType = null
      if (realType && volumetricType) {
        const realClassification = this.priceByVehicleClassification[realType]
        const volumetricClassification = this.priceByVehicleClassification[volumetricType]

        const realSurplus = realClassification && realClassification.surplus ? Number(realClassification.surplus) : 0
        const volumetricSurplus = volumetricClassification && volumetricClassification.surplus ? Number(volumetricClassification.surplus) : 0

        if (realSurplus >= volumetricSurplus) {
          vehicleType = realType
        } else {
          vehicleType = volumetricType
        }
      } else {
        vehicleType = realType || volumetricType
      }

      if (!vehicleType) {
        console.warn('No matching vehicle type found for weights:', {
          realWeight: realWeight,
          volumetricWeight: volumetricWeight
        })
      }

      this.vehicles.push({
        vin: this.VIN,
        make: this.MAKE,
        model: this.MODEL,
        trim: this.TRIM,
        year: this.YEAR.toString(),
        weight: this.WEIGHT.toString(),
        realWeight: this.REALWEIGHT.toString(),
        size: this.SIZE,
        docs: this.order.docs,
        dateSignataire: this.order.dateSignataire,
        signataire: this.userInfo.name,
        surplusRebateNote: '',
        regularPrice: 0,
        discount: 0,
        discountAmountType: '%',
        surplus: 0,
        surplusAmountType: '%',
        price: 0,
        surplusByCategory: this.billingDealer.applyVehicleSurplus === false
          ? 0
          : (this.priceByVehicleClassification[vehicleType] && this.priceByVehicleClassification[vehicleType].surplus)
            ? Number(this.priceByVehicleClassification[vehicleType].surplus)
            : 0
      })
      if (this.isPendingOrder) {
        this.order.size = this.SIZE
        this.order.realWeight = this.REALWEIGHT
      }
      this.dateTemporary = this.order.dateSignataire ? this.order.dateSignataire : Date.now()
      this.clearVehicleForm()
      this.isModelSelected = false
      this.trimOptions = []
      this.selectedTrimDetails = {}
      this.showVolumetricWeightDetails = false
      if (!this.isVinCustom) {
        this.$refs.autocomplete.value = ''
        this.$refs.autocomplete2.value = ''
        this.calculatePrice(0, this.vehicles.length - 1)
      }
    },

    toggleCustomVin () {
      this.isVinCustom = !this.isVinCustom
      this.clearVehicleForm()
      this.vinError = ''
      this.yearError = ''
      this.vinErrorMsg = ''
    },

    toggleFuelCharge (checked) {
      this.$set(this.order, 'includedFuelCharge', checked)
      this.$set(this.order, 'applyFuelCharge', !checked)
      if (!checked) {
        this.$set(this.order, 'fuelCharge', this.getDefaultFuelCharge())
      }
    },

    clearDryBoxLineForm () {
      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.TRIM = ''
      this.YEAR = ''
      this.REALWEIGHT = ''
      this.STACKABLE = false
      this.STACKED_ON = ''
      this.order.dateSignataire = ''
      if (!this.isPendingOrder) {
        this.removeOrderDocsUrl()
      }
    },

    clearVehicleForm () {
      this.VIN = ''
      this.YEAR = ''
      this.MAKE = ''
      this.MODEL = ''
      this.TRIM = ''
      this.trimOptions = []
      this.WEIGHT = ''
      this.REALWEIGHT = ''
      this.order.dateSignataire = ''
      this.$refs.toggleSwitch.updateOption(this.buttonList.not_standard)
      this.toggleClassificationMessageType(null)
      this.resetToolTip()
      this.SIZE = 1
      if (!this.isPendingOrder) {
        this.removeOrderDocsUrl()
      }
      this.vinError = ''
      this.yearError = ''
      this.selectedTrimDetails = {}
      this.showVolumetricWeightDetails = false
    },

    handleYearInput (event) {
      this.YEAR = event
    },

    // Get all the zones from store
    async getZones () {
      if (!this.$store.state.zonesLoaded) {
        await this.$store.dispatch('subscribeToZones')
      }
      this.zones = this.$store.state.zones
      const transmitterZoneById = Array.isArray(this.zones) && this.order.transmitterZoneId
        ? this.zones.find(zone => zone.id === this.order.transmitterZoneId)
        : null
      const transmitterZoneByCoordinates = this.searchZone(`${this.order.transmitterLat}, ${this.order.transmitterLong}`)
      this.transmitterZone = transmitterZoneById || transmitterZoneByCoordinates || {}
    },

    searchZone (searchCoordinates) {
      if (!searchCoordinates.trim()) return null

      const [lat, lng] = searchCoordinates.split(',').map(coord => parseFloat(coord.trim()))
      if (isNaN(lat) || isNaN(lng)) return null

      const point = turfPoint([lng, lat])
      return this.findZoneByCoordinates(point)
    },

    findZoneByCoordinates (point) {
      if (!this.zones || !Array.isArray(this.zones) || this.zones.length === 0) {
        return null
      }
      return this.zones.find(zone => {
        try {
          if (!zone.coordinates || !Array.isArray(zone.coordinates) || zone.coordinates.length < 3) return false
          // Ensure coordinates form a closed polygon
          const coordinates = [...zone.coordinates]
          if (coordinates.length > 0) {
            const [firstCoord, lastCoord] = [coordinates[0], coordinates[coordinates.length - 1]]
            if (!firstCoord || !lastCoord || !Array.isArray(firstCoord) || !Array.isArray(lastCoord)) return false
            if (firstCoord[0] !== lastCoord[0] || firstCoord[1] !== lastCoord[1]) {
              coordinates.push(firstCoord)
            }
          }
          const polygon = turfPolygon([coordinates])
          return booleanPointInPolygon(point, polygon)
        } catch (e) {
          console.warn('Error checking zone:', zone.zoneName, e)
          return false
        }
      })
    },

    setSelectedDealer (newDealer) {
      this.billingDealer = newDealer
      if (this.isZoneVerification) {
        this.calculateWarningLateTime()
      }
    },

    async getSelectedDealer () {
      if (!this.order.payer) {
        this.billingDealer = {}
        this.discountedZones = []
        return
      }
      try {
        let snapshot = await db.ref(`users/dealers/${this.order.payer}/`).once('value')
        if (snapshot.exists()) {
          this.billingDealer = snapshot.val()
          this.applyBillingAccountSettings(this.billingDealer)
          if (this.billingDealer.zones && this.billingDealer.discountType === 'Zone_Based_Discount') {
            this.discountedZones = Object.entries(this.billingDealer.zones).map(([id, zoneData]) => ({
              id,
              ...zoneData
            }))
            await this.setDiscountedZones()
          }
        }
      } catch (err) {
        console.error(err)
      }
    },

    async calculatePrice (keyEvent, index) {
      if (this.isDryBox) return
      const previousRegularPrice = Number(this.order.regularPrice) || 0
      if (!this.isFromMarketplace) {
        const hasVehicleIndex = Number.isInteger(index) && this.vehicles[index]
        const targetIndexes = hasVehicleIndex ? [index] : this.vehicles.map((vehicle, idx) => idx)

        const forEachTargetVehicle = (callback) => {
          targetIndexes.forEach((vehicleIndex) => {
            const vehicle = this.vehicles[vehicleIndex]
            if (vehicle) callback(vehicle, vehicleIndex)
          })
        }

        if ((!this.order.transmitterZoneId || !this.order.receiverZoneId) && this.vehicles.length) {
          this.order.regularPrice = 0
          forEachTargetVehicle((vehicle) => { vehicle.price = 0 })
          return
        }

        try {
          let nextRegularPrice = 0

          // Location-based pricing check
          if (Array.isArray(this.billingDealer.locationPrices)) {
            const matchingLocationPrice = this.billingDealer.locationPrices.find(locationPrice =>
              locationPrice &&
              locationPrice.pickupPlaceData &&
              locationPrice.dropoffPlaceData &&
              locationPrice.pickupPlaceData.placeId === this.order.transmitterPlaceId &&
              locationPrice.dropoffPlaceData.placeId === this.order.receiverPlaceId
            )

            if (matchingLocationPrice) {
              nextRegularPrice = Number(matchingLocationPrice.price) || 0
              forEachTargetVehicle((vehicle) => {
                vehicle.regularPrice = nextRegularPrice
              })
            }
          }
          if (this.billingDealer.discountType === 'Zone_Based_Discount' && !nextRegularPrice) {
            await this.getSelectedDealer()
            let discountedZone = this.discountedZones.find(zone => zone.id === this.order.transmitterZoneId)
            if (discountedZone) {
              nextRegularPrice = discountedZone[this.order.receiverZoneId]
                ? discountedZone[this.order.receiverZoneId].newPrice
                : 0
            }
          } else {
            if (this.billingDealer.discountType === 'Price_Based_Discount') {
              const {discountCategory, discountAmount, discountAmountType} = this.billingDealer
              const discount = discountCategory + ' ' + discountAmount + ' ' + discountAmountType
              this.order.customerDiscount = discount
              forEachTargetVehicle((vehicle) => {
                if (discountCategory === '-') {
                  vehicle.discount = discountAmount
                  vehicle.discountAmountType = discountAmountType
                } else if (discountCategory === '+') {
                  vehicle.surplus = discountAmount
                  vehicle.surplusAmountType = discountAmountType
                }
              })
            }

            await this.getZones()
            const selectedTransmitterZone = this.transmitterZone && this.transmitterZone.id
              ? this.transmitterZone
              : (Array.isArray(this.zones) ? this.zones.find(zone => zone.id === this.order.transmitterZoneId) : null)

            if (!nextRegularPrice && selectedTransmitterZone && selectedTransmitterZone[this.order.receiverZoneId]) {
              nextRegularPrice = Number(selectedTransmitterZone[this.order.receiverZoneId].price) || 0
            }
          }

          this.order.regularPrice = Number(nextRegularPrice) || 0
          if (this.order.regularPrice > 0) {
            forEachTargetVehicle((vehicle) => {
              vehicle.regularPrice = this.order.regularPrice
            })
          }

          await this.calculateWarningLateTime()
          forEachTargetVehicle((vehicle, vehicleIndex) => {
            this.calculateCarPrice(this.order.regularPrice, vehicleIndex)
          })
        } catch (err) {
          console.error('Error calculating price:', err)
          this.order.regularPrice = previousRegularPrice
        } finally {
          this.formCompleted = this.isFormCompleted()
        }
      }
    },

    openModal (zone) {
      if (this.billingDealer.discountType === 'Zone_Based_Discount') {
        this.showDealerZoneModal = true
      } else {
        this.showZoneModal = true
      }
    },

    closeModal () {
      this.showZoneModal = false
      this.showDealerZoneModal = false
    },
    onRemoveVehicle (vehicle, index) {
      this.vehicles.splice(index, 1)
      if (this.isDryBox) {
        const removedLineNumber = index + 1
        const shiftStackRef = (stackedOn) => {
          const ref = parseInt(stackedOn, 10)
          if (!ref) return stackedOn
          if (ref === removedLineNumber) return ''
          if (ref > removedLineNumber) return String(ref - 1)
          return stackedOn
        }
        this.vehicles.forEach(line => {
          if (line.stackedOn) line.stackedOn = shiftStackRef(line.stackedOn)
        })
        if (this.STACKED_ON) this.STACKED_ON = shiftStackRef(this.STACKED_ON)
      }
    },

    async updateOptionSelect (optionObj) {
      this.toggleClassificationMessageType(null)
      this.updateMakeModelFirebase(optionObj.id)
      this.SIZE = optionObj.id
    },

    updateOption () {
      this.$refs.toggleSwitch.onOptionSelect(this.buttonList.not_standard)
    },

    getVehicleSizeId (type) {
      if (type === 'light') {
        return 2
      }
      if (type === 'medium') {
        return 3
      }
      if (type === 'heavy') {
        return 4
      }
      if (type === 'extra_heavy') {
        return 5
      }
      return 1
    },

    getVehicleType (id) {
      if (id === 2) {
        return 'light'
      }
      if (id === 3) {
        return 'medium'
      }
      if (id === 4) {
        return 'heavy'
      }
      if (id === 5) {
        return 'extra_heavy'
      }
      return 'not_standard'
    },

    updateMakeModelFirebase (vehicleSizeId) {
      db.ref(`vehicleSize/${this.companyUID}/${this.returnMakeModelTrim}`).set(vehicleSizeId)
    },

    updateDropzoneFile (file) {
      this.order.docs = file
      if (this.order.docs) {
        this.order.dateSignataire = ''
      }
      if (this.isZoneVerification) {
        this.calculateWarningLateTime()
      } else {
        this.calculateWLTime()
      }
    },

  // Button: Reset date
  // Reset date of dateSignature
    resetDate () {
      this.order.dateSignataire = ''
    },

    // Button: Vehicle ready
    // Set the dateSignature to Today
    setDateSignataire () {
      this.order.dateSignataire = ''
      this.removeOrderDocsUrl()
      this.order.dateSignataire = this.formatDate(Date.now())
    },

    // Custom Input file, functions: VueDropZone file removed
    // Reset order docs, remove file from dropzone. re-enable dropzone
    removeOrderDocsUrl (file, error, xhr) {
      this.$refs.myVueDropzone.removeOrderDocsUrl()
    },

    // Called when searching a car MAKE autocomplete
    async searchCarMake (input) {
      if (input.length < 1) { return [] }
      const makes = await loadMakeModels(this.YEAR)
      var modelList = Object.keys(makes)
      return modelList.filter(country => {
        return country.toLowerCase()
          .startsWith(input.toLowerCase())
      })
    },

    // Used in conjuction with searchCarMake autocomplete
    onSubmitCarMake (result) {
      this.isModelSelected = false
      this.MAKE = result
      this.MODEL = ''
      this.TRIM = ''
      this.$refs.autocomplete2.value = ''
      // this.$refs.autocomplete3.value = ''
      this.clearOnModelSelect()
      this.VIN = ''
    },

    // Called when searching a car MODEL in autocomplete
    async searchCarModel (input) {
      this.isModelSelected = false
      if (input.length < 1) return []
      const makes = await loadMakeModels(this.YEAR)
      var modelList = Object.keys(makes[this.MAKE] || {})
      return modelList.filter(country => {
        return country.toLowerCase()
          .startsWith(input.toLowerCase())
      })
    },

    // Used in conjuction with searchCarModel autocomplete
    async onSubmitCarModel (result) {
      this.isModelSelected = true
      this.MODEL = result
      this.WEIGHT = ''
      this.$refs.toggleSwitch.updateOption(this.buttonList.not_standard)
      this.showVolumetricWeightDetails = true
      this.resetToolTip()
      this.clearVehicleClassificationDetails()
      this.VIN = ''
      const makes = await loadMakeModels(this.YEAR)
      const trimOptions = Object.keys((makes[this.MAKE] || {})[this.MODEL] || {})
      this.trimOptions = trimOptions.map(item => {
          return {
            'volumetricWeight': 0,
            'length': 0,
            'width': 0,
            'weight': '0',
            'classification': 'None',
            'trimName': item,
            'height': 0
          }
        })
        if (this.trimOptions.length) this.onSubmitCarTrim(this.trimOptions[0].trimName)
    },

    // Called when searching a car TRIM in autocomplete
    async searchCarTrim (input) {
      this.isTrimSelected = false
      this.TRIM = ''
      if (input.length < 1) { return [] }
      const makes = await loadMakeModels(this.YEAR)
      var trimList = Object.keys((makes[this.MAKE] || {})[this.MODEL] || {})
      return trimList.filter(country => country.toLowerCase().startsWith(input.toLowerCase()))
    },

    resetToolTip () {
       this.sizeTooltipText = ''
        this.sizeTooltipColor = ''
    },

    // Used in conjuction with searchCarTrim autocomplete
    // async onSubmitCarTrim (selectedTrim) {
    //   this.toggleClassificationMessageType(null)
    //   if (selectedTrim === '') {
    //     this.clearVehicleClassificationDetails()
    //     return
    //   }
    //   this.selectedTrimDetails = this.trimOptions.filter(trim => trim.trimName === selectedTrim)[0]
    //   this.isTrimSelected = true
    //   this.TRIM = selectedTrim
    //   this.WEIGHT = this.selectedTrimDetails.weight
    //   this.$refs.toggleSwitch.updateOption(this.buttonList.noSize)

    //   // Check if classification for this make, model & trim exists
    //   let vehicleSizeIdDB = await this.getVehicleClassificationDB(this.returnMakeModelTrim)
    //   let hasMakeModelTrim = vehicleSizeIdDB > 1
    //   let existingClassificationType = this.getVehicleType(vehicleSizeIdDB)
    //   const classification = this.selectedTrimDetails.classification
    //   const vehicleSizeId = this.getVehicleSizeId(classification)

    //   // Vin validation api was used
    //   if (this.isValidVin) {
    //     if (hasMakeModelTrim) {
    //       await this.getVehicleSize(this.returnMakeModelTrim)
    //       // Check if api has different data
    //       if (classification !== 'None' && classification !== existingClassificationType) {
    //         this.toggleClassificationMessageType('success', `${this.$t('OrderCurrent.modal.carInfo.suggested_classification')}: ${this.$t('Vehicles.' + classification)}`)
    //       }
    //     } else {
    //       if (classification !== 'None') {
    //         this.$refs.toggleSwitch.updateOption(this.buttonList[classification])
    //         this.SIZE = vehicleSizeId
    //         this.setSizeTooltipText(true)
    //         // also add this to the firebase for future use
    //         this.updateMakeModelFirebase(vehicleSizeId)
    //       } else {
    //         this.setSizeTooltipText(false)
    //         this.toggleClassificationMessageType('error', `${this.$t('Vehicle.size_not_found')}`)
    //       }
    //     }
    //   } else { // Manual
    //     if (hasMakeModelTrim) {
    //       await this.getVehicleSize(this.returnMakeModelTrim)
    //       this.setSizeTooltipText(true)
    //     } else {
    //       this.setSizeTooltipText(false)
    //       this.toggleClassificationMessageType('error', `${this.$t('Vehicle.size_not_found')}`)
    //     }
    //   }
    // },

    async onSubmitCarTrim (selectedTrim) {
      this.toggleClassificationMessageType(null)

      if (selectedTrim === '') {
        this.clearVehicleClassificationDetails()
        return
      }
      this.selectedTrimDetails = this.trimOptions.find(trim => trim.trimName === selectedTrim)
      this.isTrimSelected = true
      this.TRIM = selectedTrim
      // this.WEIGHT = this.selectedTrimDetails.weight
      // Convert volumetricWeight (kg) to lbs
      // const volumetricWeightKg = this.selectedTrimDetails.volumetricWeight
      // const volumetricWeightLbs = Math.round(volumetricWeightKg * 2.20462)

      this.WEIGHT = this.selectedTrimDetails.volumetricWeight
      this.REALWEIGHT = this.selectedTrimDetails.weight

      this.$refs.toggleSwitch.updateOption(this.buttonList.not_standard)

      // Calculate classification based on weight
      const classification = this.calculateVehicleClassification(this.WEIGHT)
      const vehicleSizeId = this.getVehicleSizeId(classification)
      const vehicleSizeIdDB = await this.getVehicleClassificationDB(this.returnMakeModelTrim)
      const hasMakeModelTrim = vehicleSizeIdDB > 1
      const existingClassificationType = this.getVehicleType(vehicleSizeIdDB)

      if (this.VIN && this.isValidVin) {
        if (hasMakeModelTrim) {
          await this.getVehicleSize(this.returnMakeModelTrim)
          if (classification !== 'None' && classification !== existingClassificationType) {
            this.toggleClassificationMessageType(
              'success',
              `${this.$t('OrderCurrent.modal.carInfo.suggested_classification')}: ${this.$t('Vehicles.' + classification)}`
            )
          }
        } else {
          if (classification !== 'None') {
            this.$refs.toggleSwitch.updateOption(this.buttonList[classification])
            this.SIZE = vehicleSizeId
            this.setSizeTooltipText(true)
            this.updateMakeModelFirebase(vehicleSizeId)
          } else {
            this.setSizeTooltipText(false)
            this.toggleClassificationMessageType('error', `${this.$t('Vehicle.size_not_found')}`)
          }
        }
      } else { // Manual
        if (hasMakeModelTrim) {
          await this.getVehicleSize(this.returnMakeModelTrim)
          this.setSizeTooltipText(true)
        } else {
          this.setSizeTooltipText(false)
          this.toggleClassificationMessageType('error', `${this.$t('Vehicle.size_not_found')}`)
        }
      }
    },
    calculateVehicleClassification (weight) {
      const classificationThresholds = this.getClassificationThresholds()

      for (const [classification, { lowerLimit, upperLimit }] of Object.entries(classificationThresholds)) {
        if (weight >= lowerLimit && weight <= upperLimit) {
          return classification
        }
      }

      return 'not_standard'
    },

    getClassificationThresholds () {
      const defaultThresholds = {
        light: { lowerLimit: 0, upperLimit: 1599 },
        medium: { lowerLimit: 1600, upperLimit: 2399 },
        heavy: { lowerLimit: 2400, upperLimit: 3199 },
        extra_heavy: { lowerLimit: 3200, upperLimit: 3999 },
        not_standard: { lowerLimit: 4000, upperLimit: 999999 }
      }

      const userThresholds = this.$store.state.userInfo.priceByVehicleClassification || {}

      const mergedThresholds = {}

      for (const key in defaultThresholds) {
        const defaultVal = defaultThresholds[key]
        const userVal = userThresholds[key] || {}

        mergedThresholds[key] = {
          lowerLimit: userVal.lowerLimit !== '' && userVal.lowerLimit != null ? Number(userVal.lowerLimit) : defaultVal.lowerLimit,
          upperLimit: userVal.upperLimit !== '' && userVal.upperLimit != null ? Number(userVal.upperLimit) : defaultVal.upperLimit,
          surplus: userVal.surplus !== '' && userVal.surplus != null ? Number(userVal.surplus) : (defaultVal.surplus || 0)
        }
      }

      return mergedThresholds
    },
     // Called when selecting a year from YEAR dropdown
     onSubmitVehicleYear (input) {
      this.$refs.autocomplete.value = ''
      this.$refs.autocomplete2.value = ''
      this.VIN = ''
      this.YEAR = input
      loadMakeModels(input)
      this.clearOnModelSelect()
    },

    async getVehicleClassificationDB (makeModelTrim) {
      const validMakeModelTrim = this.removeInvalidChars(makeModelTrim)
      const snapshot = await db.ref(`vehicleSize/${this.companyUID}/${validMakeModelTrim}`).once('value')
      if (snapshot.exists()) {
        return snapshot.val()
      }
      return -1
    },

    async getVehicleSize (makeModelTrim) {
      await db.ref(`vehicleSize/${this.companyUID}/${makeModelTrim}`).once('value').then((snapshot) => {
        this.SIZE = snapshot.val()

        const keys = Object.keys(this.buttonList)
        let selectedSize = keys.find(key => this.buttonList[key].id.toString() === this.SIZE.toString())
        this.$refs.toggleSwitch.onOptionSelect(this.buttonList[selectedSize])
        this.setSizeTooltipText(true)
      }).catch(() => {
        this.SIZE = 1
        this.setSizeTooltipText(false)
      })
    },

    // Called to Validate a car VIN
    validateVIN: async function (vin) {
      this.vinErrorMsg = ''
      await window.axios.get(`${process.env.API_ENDPOINT}/decode/decodevin/` + vin).then(async (response) => {
        const vin = this.VIN
        this.VIN = vin
        if (response.data.error) {
          this.vinErrorMsg = response.data.error
          this.isValidVin = false
        } else {
          this.isValidVin = true
          this.MAKE = this.MAKE || response.data.make
          this.MODEL = this.MODEL || response.data.model
          this.isModelSelected = true
          this.isTrimSelected = true
          this.YEAR = response.data.year.toString()
          this.$refs.autocomplete.value = response.data.make
          this.$refs.autocomplete2.value = response.data.model
          this.showVolumetricWeightDetails = true
          if (response.data.trims.length) {
            this.trimOptions = response.data.trims.map(item => {
              item.trimName = this.removeInvalidChars(item.trimName)
              return item
            })
            this.onSubmitCarTrim(this.trimOptions[0].trimName)
          } else {
            this.TRIM = ''
            this.trimOptions = []
            this.vinErrorMsg = this.$t('OrderInfo.information.trimErrorMessage')
          }
        }
      }).catch((error) => {
        console.log(error.message)
        this.vinErrorMsg = error.message
      })
    },

    approveOrder () {
      if (this.$refs.delivLocDetails) this.$refs.delivLocDetails.saveIdentities()
      const updatedOrder = { ...this.order }
      const acceptedPrice = this.vehicles[0] ? this.vehicles[0].price : this.order.price
      updatedOrder.price = acceptedPrice

      if (this.isDryBox && this.vehicles[0]) {
        const line = this.vehicles[0]
        updatedOrder.vin = line.vin
        updatedOrder.make = line.make
        updatedOrder.model = line.model
        updatedOrder.trim = line.trim
        updatedOrder.year = line.year
        updatedOrder.weight = line.weight
        updatedOrder.realWeight = line.realWeight
        updatedOrder.stackable = line.stackable === true
        updatedOrder.stackedOn = line.stackedOn || ''
        updatedOrder.isDryBoxOrder = true
        updatedOrder.linearFeet = Number((this.dryBoxLines[0].linearFeet || 0).toFixed(2))
        updatedOrder.trailerType = this.selectedTrailerId
        updatedOrder.isFullLoad = this.isFullLoad === true
        updatedOrder.fullLoadTotalPrice = this.isFullLoad ? (Number(this.fullLoadPrice) || 0) : 0
        updatedOrder.fullLoadMileage = this.isFullLoad ? (Number(this.fullLoadMileage) || 0) : 0
        updatedOrder.ratePerMile = this.isFullLoad ? Number(this.fullLoadRatePerMile.toFixed(2)) : 0
      }

      const acceptedNote = {
        date: Date.now(),
        name: this.setNoteName(),
        text: this.buildCreationPriceNoteText('ORDER ACCEPTED', getRealName(updatedOrder, 'payer'), acceptedPrice)
      }

      updatedOrder.notes = Array.isArray(updatedOrder.notes) ? updatedOrder.notes : []
      if (updatedOrder.notes.length === 0) updatedOrder.notes.push(acceptedNote)
      else updatedOrder.notes[updatedOrder.notes.length - 1] = acceptedNote

      updatedOrder.isPrinted = false

      this.$emit('approveOrder', updatedOrder)
    },

    sanitizeString (value) {
      if (typeof value !== 'string') return ''
      return value
        .replace(/[\u0000-\u001F\u007F]/g, '')
        .trim()
    },

    addOrder () {
      if (this.$refs.delivLocDetails && !this.$refs.delivLocDetails.prepareLogisticsContactOverride()) {
        this.formCompleted = false
        return
      }

      this.order.transpCigle = this.$store.state.userInfo.cigle
      this.order.transpName = this.$store.state.userInfo.name

      this.$refs.delivLocDetails.saveToAddressbook(this.order)
      const fieldsToClean = [
        'payerAddress',
        'transmitterAddress',
        'receiverAddress',
        'payerName',
        'transmitterName',
        'receiverName'
      ]

      fieldsToClean.forEach(field => {
        this.order[field] = this.sanitizeString(this.order[field])
      })
      ;['realPayerName', 'realTransmitterName', 'realReceiverName'].forEach(field => {
        if (typeof this.order[field] === 'string') this.order[field] = this.sanitizeString(this.order[field])
      })
      this.$refs.delivLocDetails.saveIdentities()

      for (var attr in this.order) {
        if (this.order[attr] === undefined) this.order[attr] = ''
      }
      this.vehicles.forEach((vehicle, index) => {
        this.order.selectedContactEmails = this.selectedContactEmails
        this.order.vin = vehicle.vin
        this.order.make = vehicle.make
        this.order.model = vehicle.model
        this.order.year = vehicle.year
        this.order.trim = vehicle.trim
        this.order.size = vehicle.size
        this.order.weight = vehicle.weight
        this.order.realWeight = vehicle.realWeight
        this.order.surplusRebateNote = vehicle.surplusRebateNote
        this.order.docs = vehicle.docs
        this.order.dateSignataire = vehicle.dateSignataire
        this.order.signataire = vehicle.signataire
        this.order.price = vehicle.price
        this.order.discount = vehicle.discount
        this.order.discountAmountType = vehicle.discountAmountType
        this.order.surplus = vehicle.surplus
        this.order.surplusAmountType = vehicle.surplusAmountType
        this.order.surplusByVehicleClass = vehicle.surplusByCategory
        this.order.payerOdooPartnerId = this.billingDealer.odooPartnerId || ''
        this.order.payerOdooPartnerName = this.billingDealer.odooPartnerName || ''
        this.order.zeroTax = this.billingDealer.zeroTax === true
        if (this.isDryBox) {
          this.order.isDryBoxOrder = true
          this.order.stackable = vehicle.stackable === true
          this.order.stackedOn = vehicle.stackedOn || ''
          this.order.linearFeet = Number((this.dryBoxLines[index].linearFeet || 0).toFixed(2))
          this.order.trailerType = this.selectedTrailerId
          this.order.totalLinearFeet = Number(this.dryBoxTotals.linearFeet.toFixed(2))
          this.order.capacityPercent = Number(this.dryBoxTotals.capacityPercent.toFixed(1))
          this.order.loadStatus = this.dryBoxTotals.loadStatus
          this.order.isFullLoad = this.isFullLoad === true
          this.order.fullLoadTotalPrice = this.isFullLoad ? (Number(this.fullLoadPrice) || 0) : 0
          this.order.fullLoadMileage = this.isFullLoad ? (Number(this.fullLoadMileage) || 0) : 0
          this.order.ratePerMile = this.isFullLoad ? Number(this.fullLoadRatePerMile.toFixed(2)) : 0
        }
        this.order.notes = []
        const note = {
          date: Date.now(),
          name: this.setNoteName(),
          text: this.buildCreationPriceNoteText('ORDER CREATED', getRealName(this.order, 'payer'), this.order.price)
        }
        this.order.notes.push(note)
        if (!this.isZoneVerification && !this.order.regularPrice) {
          this.order.regularPrice = vehicle.regularPrice
        }
        db.ref('test/transporter/' + this.companyUID + '/newDeliveries').push().set(this.order).then(() => {
          // ======================== ADD ORDER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_ORDER', 'date': Date.now(), 'targetName': getRealName(this.order, 'payer')})
        }).catch(function (error) {
          console.log(error)
        })
      })
      this.clearNewOrderModal()
    },

    selectDiscountAmountType (operation, index) {
      this.calculateCarPrice(this.vehicles[index].discountAmountType = operation, index)
    },

    selectSurplusAmountType (operation, index) {
      this.calculateCarPrice(this.vehicles[index].surplusAmountType = operation, index)
    },

    /** Reinitialize data for new order modal */
    clearNewOrderModal () {
      this.clearData()
      // this.clearEmailList()
      this.$emit('closeNewOrderModal')
    },

    async handleZoneUpdate () {
      if (!this.isZoneVerification) return
      await this.refreshZonePricing()
    },

    async refreshZonePricing () {
      if (!this.isZoneVerification) return
      if (this.order.payer) {
        await this.getSelectedDealer()
      }
      await this.getZones()
      for (let idx = 0; idx < this.vehicles.length; idx++) {
        await this.calculatePrice(0, idx)
      }
      if (!this.vehicles.length) {
        await this.calculateWarningLateTime()
      }
      this.formCompleted = this.isFormCompleted()
    },

    verifySurplusRebate () {
      this.formCompleted = this.isFormCompleted()
    },

    // Called on key events when typing a price in the Add New Order modal
    calculateCarPrice (keyEvent, index) {
      if (this.vehicles[index]) {
        const vehicle = this.vehicles[index]
        let discountAmount = 0
        let surplusAmount = 0
        let { regularPrice } = this.isZoneVerification ? this.order : vehicle
        const surplusByVehicleClass = ((Number(regularPrice) * Number(vehicle.surplusByCategory)) / 100) || 0

        regularPrice = Number(regularPrice) + surplusByVehicleClass
        if (vehicle.discountAmountType && vehicle.discountAmountType === '$') {
          discountAmount = Number(vehicle.discount)
        } else {
          discountAmount = ((Number(regularPrice) * Number(vehicle.discount)) / 100)
        }
        if (vehicle.surplusAmountType && vehicle.surplusAmountType === '$') {
          surplusAmount = Number(vehicle.surplus)
        } else {
          surplusAmount = ((Number(regularPrice) * Number(vehicle.surplus)) / 100)
        }
        discountAmount = isNaN(discountAmount) ? 0 : discountAmount
        surplusAmount = isNaN(surplusAmount) ? 0 : surplusAmount

        vehicle.price = (((Number(regularPrice)) - discountAmount) + surplusAmount).toFixed(2)

        this.verifyPriceValues()
        this.formCompleted = this.isFormCompleted()
      }
    },

    addBusinessDays (startDate, daysToAdd) {
      let currentDate = new Date(startDate)
      let addedDays = 0

      while (addedDays < daysToAdd) {
        currentDate.setDate(currentDate.getDate() + 1)
        const dayOfWeek = currentDate.getDay()

        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          addedDays++
        }
      }
      return currentDate
    },

    calculateWLTime (keyEvent) {
      if (this.order.docs) {
        this.dateTemporary = Date.now()
      }
      const warningTime = this.warningTime
      const lateTime = this.lateTime
      const dateSignataire = new Date(this.order.dateSignataire ? this.order.dateSignataire : this.dateTemporary)
      const newWarningTime = this.addBusinessDays(dateSignataire, warningTime)
      const newLateTime = this.addBusinessDays(dateSignataire, lateTime)
      this.$set(this.order, 'warningTime', warningTime !== 0 ? newWarningTime.getTime() : 0)
      this.$set(this.order, 'lateTime', lateTime !== 0 ? newLateTime.getTime() : 0)
      this.formCompleted = this.isFormCompleted()
    },

    async calculateWarningLateTime () {
      await this.setDiscountedZones()
      let transmitterId = this.order.transmitterZoneId
      let warningTime = 0
      let lateTime = 0

      if (this.order.docs) {
        this.dateTemporary = Date.now()
      }
      if ((this.vehicles.length || this.order.dateSignataire || this.order.docs) && this.order.transmitterZoneId && this.order.receiverZoneId) {
        if (this.billingDealer.discountType === 'Zone_Based_Discount') {
          let discountedZone = this.discountedZones.find(zone => zone.id === transmitterId)
          if (discountedZone) {
            try {
              warningTime = discountedZone[this.order.receiverZoneId].newWarningTime
              lateTime = discountedZone[this.order.receiverZoneId].newLateTime
            } catch (err) {
              warningTime = 0
              lateTime = 0
            }
          }
        } else {
          try {
            let regularZone = this.zones.find((zone) => zone.id === transmitterId)
            if (regularZone && regularZone[this.order.receiverZoneId]) {
              warningTime = regularZone[this.order.receiverZoneId].warningTime || 0
              lateTime = regularZone[this.order.receiverZoneId].lateTime || 0
            }
          } catch (err) {
            warningTime = 0
            lateTime = 0
          }
        }

        this.warningTime = warningTime
        this.lateTime = lateTime
        const dateSignataire = new Date(this.order.dateSignataire ? this.order.dateSignataire : this.dateTemporary)
        const newWarningTime = this.addBusinessDays(dateSignataire, warningTime)
        const newLateTime = this.addBusinessDays(dateSignataire, lateTime)
        this.$set(this.order, 'warningTime', warningTime !== 0 ? newWarningTime.getTime() : 0)
        this.$set(this.order, 'lateTime', lateTime !== 0 ? newLateTime.getTime() : 0)
        this.$set(this.order, 'initialLateTime', lateTime !== 0 ? newLateTime.getTime() : 0)
      } else {
        this.warningTime = 0
        this.lateTime = 0
        this.$set(this.order, 'warningTime', 0)
        this.$set(this.order, 'lateTime', 0)
        this.$set(this.order, 'initialLateTime', 0)
      }
      this.formCompleted = this.isFormCompleted()
    },

    async setDiscountedZones () {
      if (this.billingDealer.zones) {
              this.discountedZones = Object.entries(this.billingDealer.zones).map(([id, zoneData]) => ({
                id,
                ...zoneData
              }))
          }
    },

    /** From @emits 'sendSelectedEmails' @DeliveryLocationDetails */
    updateSelectedEmails (selectedEmails) {
      this.selectedContactEmails = selectedEmails
    },

    updateLogisticsContactValidation ({active, valid}) {
      this.logisticsContactSelectionValid = !active || valid === true
      this.formCompleted = this.isFormCompleted()
    },

    validatePricing: function (names) {
      window.axios.get(`${process.env.API_ENDPOINT}/decode/pad/pricing/e58ff614-8449-4c3e-90b8-b42a48c2972b/` + names).then((response) => {
        this.pricingAndDelay = response.data
      }).catch((error) => console.log(error))
    },

    clearOnModelSelect () {
      this.WEIGHT = ''
      this.$refs.toggleSwitch.updateOption(this.buttonList.not_standard)
      this.showVolumetricWeightDetails = false
      this.resetToolTip()
      this.clearVehicleClassificationDetails()
      this.trimOptions = []
      this.toggleClassificationMessageType(null)
    },
    clearVehicleClassificationDetails () {
      this.selectedTrimDetails = {}
      this.isTrimSelected = false
      this.TRIM = ''
      this.WEIGHT = ''
      this.$refs.toggleSwitch.updateOption(this.buttonList.not_standard)
      this.resetToolTip()
      this.showVolumetricWeightDetails = false
    },

    /** Clear all data for new order modal */
    clearData () {
      this.VIN = ''
      this.YEAR = ''
      this.MAKE = ''
      this.MODEL = ''
      this.TRIM = ''
      this.WEIGHT = ''
      this.REALWEIGHT = ''
      this.STACKABLE = false
      this.STACKED_ON = ''
      this.isFullLoad = false
      this.fullLoadPrice = ''
      this.fullLoadMileage = ''
      this.isValidVin = false
      this.vehicles = []
      this.selectedContactEmails = []
      this.logisticsContactSelectionValid = true
      this.pricingAndDelay = []
    },

    removeInvalidChars (text) {
      text = text.replace('.', '')
      text = text.replace('$', '')
      text = text.replace('#', '')
      text = text.replace('[', '')
      text = text.replace(']', '')
      text = text.replace('/', '')
      return text
    },

    formatDate (date) {
      var fdate = new Date(date)
      return fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)
    },

    verifyPriceValues () {
      if (this.order.regularPrice <= 0) {
        this.order.regularPrice = 0
      }

      if (this.order.discount <= 0) {
        this.order.discount = 0
      }

      if (this.order.surplus <= 0) {
        this.order.surplus = 0
      }

      if (this.order.price <= 0) {
        this.order.price = 0
      }
    },

    isFormCompleted () {
      let order = this.order

      let vehicleNoteComplete = true

      this.vehicles.forEach(vehicle => {
        if ((Number(vehicle.surplus) || Number(vehicle.discount)) && !vehicle.surplusRebateNote) {
          vehicleNoteComplete = false
          return
        }
      })
      return (
        // this.vehicles.length !== 0 &&
        order.receiverName !== '' &&
        order.receiverAddress !== '' &&
        order.receiverCountry !== '' &&
        order.receiverCity !== '' &&
        order.receiverPostcode !== '' &&
        order.receiverProvince !== '' &&
        order.payerName !== '' &&
        order.payerAddress !== '' &&
        order.payerCity !== '' &&
        order.payerPostcode !== '' &&
        order.payerProvince !== '' &&
        order.transmitterName !== '' &&
        order.transmitterAddress !== '' &&
        order.transmitterCountry !== '' &&
        order.transmitterCity !== '' &&
        order.transmitterPostcode !== '' &&
        order.transmitterProvince !== '' &&
        (order.transmitterZone !== '' || this.isFromMarketplace || !this.isZoneVerification) &&
        (order.receiverZone !== '' || this.isFromMarketplace || !this.isZoneVerification) &&
        (order.regularPrice !== 0 || !this.isZoneVerification) &&
        order.warningTime !== 0 &&
        order.lateTime !== 0 &&
        this.logisticsContactSelectionValid &&
        vehicleNoteComplete
      )
        // ((this.isSageOne && this.checkAllvehiclesPrice() && !!order.sageID) || !this.isSageOne))
    },

    checkAllvehiclesPrice () {
      let flag = true
      this.vehicles.forEach((vehicle) => {
        if (!vehicle.price) flag = false
      })
      return flag
    },
    checkArchiveForNotFound () {
      this.notFoundVins.forEach(vin => {
        const url = `https://archivesapi.keepneye.com/search/decode/search/${this.companyUID}/vin=${vin}`

        window.axios.get(url)
          .then(res => {
            const data = res.data

            const regularMatches = data && Array.isArray(data.deliveries)
              ? data.deliveries
                .filter(isRegularOrder)
                .map(order => ({
                  ...order,
                  orderNumber: order.orderNumber || order.orderNb || order['.key'] || ''
                }))
              : []

            if (regularMatches.length > 0) {
              this.matchedVins.push(...regularMatches)

              this.notFoundVins = this.notFoundVins.filter(v => v !== vin)
            }
          })
      })
    }
  },

  computed: {
    returnMakeModelTrim () {
      const make = this.MAKE.toLowerCase()
      const model = this.MODEL.toLowerCase()
      const trim = this.TRIM.toLowerCase()
      let makeModelTrim = make.split(' ').join('') + model.split(' ').join('') + trim.split(' ').join('')
      makeModelTrim = this.removeInvalidChars(makeModelTrim)
      if (makeModelTrim.length <= 0) makeModelTrim = 'NoMakeModelTrim'
      return makeModelTrim
    },
    totalOrderFees () {
      if (!Array.isArray(this.order.fees)) return 0
      return this.order.fees.reduce((total, fee) => total + (Number(fee.amount) || 0), 0)
    },
    isFuelChargeIncluded () {
      return this.order.includedFuelCharge === true || this.order.applyFuelCharge === false
    },
    fuelChargeInputValue () {
      return this.isFuelChargeIncluded ? 0 : this.order.fuelCharge
    },
    vehiclesSubtotal () {
      return this.vehicles.reduce((total, vehicle) => total + this.getVehicleBasePrice(vehicle), 0)
    },
    vehiclesFuelChargeTotal () {
      return this.vehicles.reduce((total, vehicle) => total + this.getVehicleFuelChargeAmount(vehicle), 0)
    },
    vehiclesBillTotal () {
      return this.vehicles.reduce((total, vehicle) => total + this.getVehicleBillTotal(vehicle), 0)
    },
    createdOrdersFeesTotal () {
      return this.totalOrderFees * this.vehicles.length
    },
    allOrdersBillTotal () {
      return this.vehiclesBillTotal + this.createdOrdersFeesTotal
    },
    isZoneVerification () {
      return (this.$store.state.userInfo.isZoneVerification || false) && !this.isDryBox
    },

    dryBoxTrailer () {
      return TRAILER_TYPES[this.selectedTrailerId] || TRAILER_TYPES[DEFAULT_TRAILER_ID]
    },

    dryBoxTrailerOptions () {
      return Object.values(TRAILER_TYPES)
    },

    dryBoxLineWeight () {
      return lineTotalWeight(this.YEAR, this.REALWEIGHT)
    },

    isDryBoxTwoWide () {
      return isTwoWide(this.MODEL)
    },

    dryBoxLineLinearFeetPreview () {
      return lineLinearFeet({ lengthIn: this.MAKE, widthIn: this.MODEL, qty: this.YEAR, stackedOn: this.STACKED_ON })
    },

    dryBoxLineCompleted () {
      return this.VIN.trim() !== '' &&
        Number(this.MAKE) > 0 &&
        Number(this.MODEL) > 0 &&
        Number(this.TRIM) > 0 &&
        parseInt(this.YEAR, 10) > 0 &&
        Number(this.REALWEIGHT) > 0
    },

    dryBoxLines () {
      return this.vehicles.map(vehicle => ({
        ...vehicle,
        linearFeet: lineLinearFeet({ lengthIn: vehicle.make, widthIn: vehicle.model, qty: vehicle.year, stackedOn: vehicle.stackedOn }),
        lineWeight: Number(vehicle.weight) || 0
      }))
    },

    dryBoxTotals () {
      const linearFeet = this.dryBoxLines.reduce((total, line) => total + line.linearFeet, 0)
      const weight = this.dryBoxLines.reduce((total, line) => total + line.lineWeight, 0)
      const price = this.vehiclesSubtotal
      const pct = capacityPercent(linearFeet, this.dryBoxTrailer)
      return {
        linearFeet,
        weight,
        price,
        capacityPercent: pct,
        loadStatus: loadStatusFromPercent(pct),
        pricePerLinearFoot: linearFeet > 0 ? price / linearFeet : 0,
        pricePerLb: weight > 0 ? price / weight : 0
      }
    },

    dryBoxLoadStatusLabel () {
      const statusKeys = {
        [LOAD_STATUS.EMPTY]: 'DryBox.status_empty',
        [LOAD_STATUS.PARTIAL]: 'DryBox.status_partial',
        [LOAD_STATUS.FULL]: 'DryBox.status_full'
      }
      return this.$t(statusKeys[this.dryBoxTotals.loadStatus])
    },

    dryBoxAlerts () {
      if (!this.isDryBox || !this.vehicles.length) return []
      const alerts = []
      const totals = this.dryBoxTotals
      const trailer = this.dryBoxTrailer
      if (totals.weight > trailer.maxWeightLbs) alerts.push(this.$t('DryBox.alert_overweight'))
      if (totals.linearFeet > trailer.lengthFt) alerts.push(this.$t('DryBox.alert_over_length'))
      const hasOverweightStack = this.dryBoxLines.some(line => {
        if (!line.stackedOn) return false
        const base = this.dryBoxLines[parseInt(line.stackedOn, 10) - 1]
        if (!base) return false
        return line.lineWeight + base.lineWeight > STACKED_MAX_COMBINED_WEIGHT_LBS
      })
      if (hasOverweightStack) alerts.push(this.$t('DryBox.alert_stacked_weight'))
      if (totals.linearFeet > 0 && totals.weight / totals.linearFeet > MAX_AVG_WEIGHT_PER_LINEAR_FOOT_LBS) {
        alerts.push(this.$t('DryBox.alert_avg_weight'))
      }
      return alerts
    },

    dryBoxStackTargets () {
      return this.vehicles
        .map((vehicle, index) => ({ value: String(index + 1), label: `#${index + 1} — ${vehicle.vin}`, stackable: vehicle.stackable === true }))
        .filter(target => target.stackable)
    },

    fullLoadRatePerMile () {
      const mileage = Number(this.fullLoadMileage)
      if (!(mileage > 0)) return 0
      return (Number(this.fullLoadPrice) || 0) / mileage
    },
    returnIsModelSelected () {
      return this.isModelSelected
    },

    vehicleFormCompleted: function () {
      if (this.isDryBox) return this.dryBoxLineCompleted
      return (
        (
          this.order.dateSignataire ||
          this.order.docs
        ) &&
        !this.vinError &&
        !this.yearError
      )
    },

    getWarningTime () {
      return this.warningTime || 0
    },

    getLateTime () {
      return this.lateTime || 0
    },

    getVIN () {
      return this.VIN || ''
    },

    getMake () {
      return this.MAKE || ''
    },

    getModel () {
      return this.MODEL || ''
    },

    getYear () {
      return this.YEAR || ''
    },

    getDate () {
      return this.order.dateSignataire
    },

    userInfo () {
      return this.$store.state.userInfo
    },

    uid () {
      return this.$store.state.user.uid
    },

    companyUID () {
      return this.$store.state.authorization.company
    },

    sageOneCheck () {
      return this.isSageOne ? (!!this.order.sageID) : true
    },

    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    }
  },

  watch: {
    billingDealer (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.billingLatLong.lat = newVal.lat
        this.billingLatLong.long = newVal.long
      }
    },
    async 'order.transmitterPlaceId' (newVal, oldVal) {
      if (!this.isZoneVerification) return
      if (newVal !== oldVal) {
        await this.refreshZonePricing()
      }
    },
    VIN (newVal, oldVal) {
      if (this.isDryBox) return
      const normalizedVin = (newVal || '').trim().toUpperCase()
      const normalizedOldVin = (oldVal || '').trim().toUpperCase()
      this.matchedVins = []
      this.notFoundVins = []

      // Duplicate VIN check should only happen once VIN is fully entered.
      if (normalizedVin.length !== 17) {
        this.openSearchVins = false
        return
      }

      if (normalizedVin !== normalizedOldVin && this.vinsList.length !== 0) {
        const vinsMap = new Map(
          this.vinsList
            .filter(v => v && v.vin)
            .map(v => [v.vin.toUpperCase(), v])
        )

        const exactMatch = vinsMap.get(normalizedVin)
        if (exactMatch) this.matchedVins.push(exactMatch)
        else this.notFoundVins.push(normalizedVin)

        this.openSearchVins = true
      }

      if (this.notFoundVins.length) {
        this.checkArchiveForNotFound()
      }
    },
    async 'order.receiverPlaceId' (newVal, oldVal) {
      if (!this.isZoneVerification) return

      if (newVal !== oldVal) {
        await this.refreshZonePricing()
      }
    },

    async showZoneModal (newVal, oldVal) {
      if (!this.isZoneVerification) return
      if (oldVal === true && newVal === false) {
        await this.refreshZonePricing()
      }
    },

    async showDealerZoneModal (newVal, oldVal) {
      if (!this.isZoneVerification) return
      if (oldVal === true && newVal === false) {
        await this.refreshZonePricing()
      }
    },

    async showNewZoneModal (newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        await this.refreshZonePricing()
      }
    }

  },

  async mounted () {
    await this.initializeModal()
    if (this.isZoneVerification &&
      this.vehicles.length &&
      Number(this.order.regularPrice) === 0 &&
      this.order.transmitterZoneId &&
      this.order.receiverZoneId) {
      await this.refreshZonePricing()
    }
    const startYear = 1981 // Start value for year
    const endYear = 2028   // End value for year
    this.years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i)
  }
}

</script>

<style>
  #addOrder, #customView{
    position: relative;
  }
  .toggleSwitch {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap:1rem;
    flex-wrap: wrap;
  }
  .newOrder__container--display {
    display: flex;
    flex-flow: row;
    width: 50%;
  }

  .newOrder__container--display-mobile {
    display: flex;
    flex-flow: column;
    width: 100%;
  }

  .document-date__container {
    display: flex;
    justify-content: space-between;
  }

  .document-date__container--mobile {
    flex-direction: column;
  }

  .document-date__item {
    width: 45%;
  }

  .document-date__item--mobile {
    width: 100%;
  }

  .document-date__button-red {
    background-color: rgb(255, 58, 58);
  }

  input[type="number"]::-webkit-inner-spin-button, 
  input[type="number"]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] { 
    -moz-appearance: textfield;
  }

  .pr-d {
    display: flex;
    justify-content: space-between;
    row-gap: 5px;
  }

  .price-column {
    width: 48%;
  }

  .input-with-buttons {
    display: flex;
    align-items: stretch;
    height: 38px; /* Adjust this value to match your input height */
  }

  .input-with-buttons .form-group {
    margin-bottom: 0;
    flex-grow: 1;
  }

  .button-group {
    display: flex;
    margin-left: 5px;
  }
  .price-row {
    display: flex;
    flex-wrap: wrap; /* allow wrapping */
    justify-content: space-between;
    margin-bottom: 1rem;
    gap: 1rem; /* add spacing between columns */
  }

  .price-column {
    flex: 1 1 calc(20% - 1rem); 
    min-width: 200px;
  }
  .fuel-charge-control .form-group {
    margin-bottom: 4px;
  }
  .fuel-charge-control__checkbox .custom-control {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    .price-column {
      flex: 1 1 calc(50% - 1rem);
    }
  }

  @media (max-width: 480px) {
    .price-column {
      flex: 1 1 100%;
    }
  }

  .input-with-buttons {
    display: flex;
    align-items: center;
  }
  .m-b-8 {
    margin-bottom: 8px;
  }
  .pr-ctr input:disabled {
    background-color: #fff;
  }
  .w-btn {
    width: 30px;
    background-color: white;
    border: 1px solid #ddd;
    height: max-content;
    padding-top: 5.5px;
    padding-bottom: 5.5px;
  }
  .w-btn:focus {
    outline: none;
  }
  .w-btn.selected {
    background-color: #d6d6d6;
  }
  .n-b-r {
    border-right: none !important;
}
  .classification-text{
    max-width:375px;
  }
  .classification-success-text{
    color: #008000;
  }
  .classification-error-text{
    color: #ff0000;
  }
  .formula{
    font-size: 14px;
  }
  .toggle-switch{
    height: 40px;
  }
  .order-total-summary {
    border: 1px solid #ddd;
    border-radius: 6px;
    margin: 12px 0;
    max-width: 420px;
    padding: 10px 14px;
  }
  .order-total-summary__row {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
  }
  .order-total-summary__row--total {
    border-top: 1px solid #ddd;
    font-size: 1.05rem;
    margin-top: 4px;
    padding-top: 8px;
  }
.kne-title {
  color: #666;
  font-weight: 500;
}
</style>
